// PALMEX · Foto-Fit (blocks/px-fotofit.liquid, René 08.10.2026). Größenberater, der nicht „deine Größe“ sucht, sondern
// die Größe, in der das Teil an dir so sitzt wie am Model auf dem Foto (bzw. wie der Schnitt gedacht ist).
// - Körpermaße aus Größe, Gewicht, Figur: Regressionen aus ANSUR II (US Army 2012, gemeinfrei, 6.068 Vermessene),
//   y = a + b·Größe + c·Gewicht + d·Gewicht²/100; Schultern/Bauch verschieben um die Reststreuung.
// - Maße der Teile: Theme-Einstellung „Foto-Fit: Maße“ (je Schnitt ein Abschnitt), Model-Angabe: Metafeld custom.model.
// - Alles wird im Browser gerechnet. Gespeichert wird nur, wenn „Auf diesem Gerät merken“ angehakt ist (localStorage).

const KOEFF = {"h":{"akr":[19.58,0.0914,0.0798,-0.0119,1.45],"delt":[38.094,-0.0624,0.3422,-0.0712,1.48],"brB":[17.249,0.0026,0.1715,-0.0457,1.29],"brU":[87.791,-0.2953,1.007,-0.2148,3.17],"taB":[25.916,-0.1046,0.3492,-0.0635,1.58],"taU":[89.679,-0.4393,1.106,-0.1736,4.37],"hfB":[21.198,-0.007,0.1954,-0.0279,1.28],"hfU":[68.377,-0.1436,0.8358,-0.1689,2.58],"hals":[33.576,-0.0405,0.2489,-0.057,1.62],"kopfB":[15.232,-0.0087,0.0253,-0.0057,0.52],"ohr":[9.815,0.0138,0.0163,-0.0069,0.6],"c7H":[-7.183,0.8829,0.0639,-0.0213,1.07],"akrH":[-9.695,0.8525,0.0536,-0.007,1.53],"achselH":[-14.725,0.8502,-0.03,0.0118,1.47],"brH":[-6.621,0.7869,-0.0582,0.0334,1.81],"taH":[-22.257,0.7443,-0.0111,-0.0247,2.07],"beckenH":[-15.676,0.7048,-0.0302,0.0086,2.15],"trochH":[-15.847,0.6324,-0.0962,0.0414,2.57],"poH":[-14.117,0.618,-0.1143,0.0553,2.8],"schrittH":[-19.27,0.6205,-0.0798,0.0229,2.34],"knieH":[-10.572,0.3432,-0.0187,0.0099,1.55],"knoechelH":[0.9566,0.0309,0.0131,-0.0029,0.49],"handgH":[-2.546,0.464,0.0779,-0.0113,2.02],"oberarm":[-2.018,0.2172,0.0062,-0.0037,1.05],"armA":[-4.02,0.3629,-0.0074,0.0032,1.84],"armR":[15.543,0.3665,0.1383,-0.0285,2.32],"bizU":[30.852,-0.1243,0.3988,-0.0973,1.86],"uarmU":[21.229,-0.0326,0.2295,-0.0548,1.28],"handgU":[9.438,0.0252,0.0474,-0.0042,0.6],"handL":[2.957,0.0883,0.0107,-0.0006,0.73],"handB":[4.124,0.0175,0.0255,-0.0073,0.35],"oschU":[48.215,-0.1867,0.6847,-0.1526,2.21],"wadeU":[30.464,-0.0697,0.3008,-0.0628,1.59],"knoU":[13.812,0.0075,0.1091,-0.0203,1.01],"fussL":[3.741,0.1202,0.0355,-0.0102,0.88],"fussB":[5.497,0.018,0.0189,-0.0012,0.42],"brT":[20.735,-0.0908,0.3012,-0.0688,1.22],"taT":[29.215,-0.1536,0.264,-0.0139,1.65]},"d":{"akr":[10.131,0.1262,0.1341,-0.0688,1.47],"delt":[32.582,-0.0668,0.4392,-0.1367,1.4],"brB":[17.211,-0.0152,0.2333,-0.0768,1.3],"brU":[88.071,-0.3365,1.077,-0.2459,4.24],"taB":[25.963,-0.1162,0.3953,-0.0814,1.81],"taU":[88.993,-0.4801,1.305,-0.2786,4.82],"hfB":[22.265,-0.0342,0.3379,-0.0892,1.48],"hfU":[70.767,-0.1878,1.131,-0.3122,2.89],"hals":[25.625,0.008,0.1718,-0.0307,1.34],"kopfB":[12.443,0.003,0.044,-0.024,0.5],"ohr":[8.873,0.0126,0.04,-0.0212,0.63],"c7H":[-7.086,0.9069,-0.0367,0.0308,1.05],"akrH":[-7.187,0.8539,0.0207,0.0051,1.34],"achselH":[-11.978,0.8556,-0.0857,0.05,1.4],"brH":[-14.443,0.8344,-0.0788,0.0227,2.19],"taH":[-21.899,0.7655,-0.0772,0.0103,2.0],"beckenH":[-15.871,0.7011,0.0294,-0.0153,2.0],"trochH":[-11.59,0.5911,-0.0103,0.0121,2.29],"poH":[-11.563,0.5745,0.0144,0.0085,2.47],"schrittH":[-18.44,0.6213,-0.0991,0.0468,2.34],"knieH":[-9.431,0.3352,-0.0141,0.015,1.39],"knoechelH":[-0.2741,0.0332,0.032,-0.0217,0.46],"handgH":[-0.4137,0.4823,0.0096,0.0135,1.97],"oberarm":[-3.119,0.2145,0.0413,-0.025,0.98],"armA":[-3.919,0.3459,0.0374,-0.0124,1.78],"armR":[6.51,0.3875,0.2311,-0.0975,2.08],"bizU":[30.311,-0.1425,0.4057,-0.0859,1.39],"uarmU":[18.465,-0.034,0.2475,-0.07,1.05],"handgU":[7.087,0.0273,0.0739,-0.0224,0.53],"handL":[3.775,0.0852,-0.004,0.0155,0.75],"handB":[3.615,0.0172,0.0292,-0.0122,0.32],"oschU":[47.827,-0.2013,0.8523,-0.2372,2.24],"wadeU":[25.981,-0.0545,0.3703,-0.1033,1.69],"knoU":[10.278,0.0116,0.1967,-0.0832,1.17],"fussL":[2.972,0.1175,0.0499,-0.0182,0.83],"fussB":[5.181,0.0134,0.0373,-0.0132,0.4],"brT":[24.516,-0.1185,0.3391,-0.0732,1.52],"taT":[31.295,-0.1813,0.2947,-0.0092,1.66]}};
const HOEHEN = ['c7H', 'akrH', 'achselH', 'brH', 'taH', 'beckenH', 'trochH', 'poH', 'schrittH', 'knieH', 'knoechelH', 'handgH'];

function koerper({ bau = 'h', h = 175, w = 75, schulter = 0, bauch = 0, huefte = 0, oberweite = 0 }) {
  const K = KOEFF[bau] || KOEFF.h;
  const wMax = bau === 'd' ? 120 : 144;
  const wMin = bau === 'd' ? 38 : 42;
  const wc = Math.min(Math.max(w, wMin), wMax);
  const m = { bau, h, w, sd: {} };
  for (const [n, [a, b, c, d, sd]] of Object.entries(K)) {
    let y = a + b * h + c * wc + (d * wc * wc) / 100;
    if (w !== wc) {
      const steigung = c + (2 * d * wc) / 100;
      y += (HOEHEN.includes(n) ? steigung : Math.max(0, steigung)) * (w - wc);
    }
    m[n] = y;
    m.sd[n] = sd;
  }
  m.akr += schulter * m.sd.akr * 1.3;
  m.delt += schulter * m.sd.delt * 1.4;
  m.brB += schulter * m.sd.brB * 0.6;
  m.brU += schulter * m.sd.brU * 0.35 + bauch * m.sd.brU * 0.25;
  m.taU += bauch * m.sd.taU * 1.4;
  m.taB += bauch * m.sd.taB * 1.5;
  m.hfB += bauch * m.sd.hfB * 0.3 + huefte * m.sd.hfB * 1.4;
  m.hfU += huefte * m.sd.hfU * 1.4;
  m.oschU += huefte * m.sd.oschU;
  // Unterbrustumfang misst ANSUR II nicht: Anteil am Brustumfang (Frauen 0,835 – entspricht etwa 75B/80C in den
  // Konfektionstabellen; Männer 0,93). Die Oberweite (nur beim Sport-BH abgefragt) verschiebt allein den Brustumfang.
  m.ubU = m.brU * (bau === 'd' ? 0.835 : 0.93);
  m.brU += oberweite * m.sd.brU * 1.2;
  return m;
}

// ---------- Farben ----------
const hexRgb = (h) => {
  const s = h.replace('#', '');
  const v = s.length === 3 ? s.split('').map((c) => c + c).join('') : s;
  return [0, 2, 4].map((i) => parseInt(v.slice(i, i + 2), 16));
};
const rgbHex = (r) => '#' + r.map((x) => Math.round(Math.max(0, Math.min(255, x))).toString(16).padStart(2, '0')).join('');
const mische = (a, b, t) => rgbHex(hexRgb(a).map((x, i) => x + (hexRgb(b)[i] - x) * t));
const hell = (h) => {
  const [r, g, b] = hexRgb(h).map((x) => {
    const c = x / 255;
    return c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4;
  });
  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
};

// ---------- Kurven ----------
const r1 = (n) => Math.round(n * 10) / 10;
// Catmull-Rom → Bézier; Punkte mit drittem Wert true sind Ecken
function kurve(p, zu = false, t = 1) {
  const n = p.length;
  if (n < 2) return '';
  const g = (i) => (zu ? p[(i + n) % n] : p[Math.max(0, Math.min(n - 1, i))]);
  let d = `M${r1(p[0][0])} ${r1(p[0][1])}`;
  const ende = zu ? n : n - 1;
  for (let i = 0; i < ende; i++) {
    const p0 = g(i - 1), p1 = g(i), p2 = g(i + 1), p3 = g(i + 2);
    const c1 = p1[2] ? p1 : [p1[0] + ((p2[0] - p0[0]) * t) / 6, p1[1] + ((p2[1] - p0[1]) * t) / 6];
    const c2 = p2[2] ? p2 : [p2[0] - ((p3[0] - p1[0]) * t) / 6, p2[1] - ((p3[1] - p1[1]) * t) / 6];
    d += `C${r1(c1[0])} ${r1(c1[1])} ${r1(c2[0])} ${r1(c2[1])} ${r1(p2[0])} ${r1(p2[1])}`;
  }
  return d + (zu ? 'Z' : '');
}
const spiegel = (l) => l.slice().reverse().map(([x, y, e]) => [-x, y, e]);
const plus = (a, b, s = 1) => [a[0] + b[0] * s, a[1] + b[1] * s];
const norm = (v) => {
  const l = Math.hypot(v[0], v[1]) || 1;
  return [v[0] / l, v[1] / l];
};
const lerp = (a, b, t) => a + (b - a) * t;

// Halbe Körperbreite (mit Hose) in Höhe y
function breiteBei(m, y) {
  const P = [
    [m.achselH, m.brB / 2],
    [m.taH, m.taB / 2],
    [m.beckenH, (m.taB / 2) * 0.45 + (m.hfB / 2) * 0.55 + 0.6],
    [m.trochH, m.hfB / 2 + 1.5],
    [m.schrittH, m.hfB / 2 + 1.1],
    [m.knieH, Math.max(m.hfB / 4, 7.2) + 8.5],
  ];
  if (y >= P[0][0]) return P[0][1];
  for (let i = 1; i < P.length; i++)
    if (y >= P[i][0]) return lerp(P[i][1], P[i - 1][1], (y - P[i][0]) / (P[i - 1][0] - P[i][0]));
  return P[P.length - 1][1];
}

// ---------- Kleidungsarten ----------
// kragen: kapuze, rund, rund-duenn, roll, steh, hemd, rippkragen · zu: rv (Reißverschluss), knopf · saum: rippe, bund,
// offen · aermelEnde: rippe, gummi, manschette, offen · tasche: kaenguru, seiten, aufgesetzt, brust
const ARTEN = {
  hoodie: { kragen: 'kapuze', saum: 'rippe', aermelEnde: 'rippe', tasche: 'kaenguru', kordel: true },
  zip: { kragen: 'kapuze', zu: 'rv', saum: 'rippe', aermelEnde: 'rippe', tasche: 'kaenguru', kordel: true },
  sweater: { kragen: 'rund', saum: 'rippe', aermelEnde: 'rippe' },
  shirt: { kragen: 'rund-duenn', saum: 'offen', aermelEnde: 'offen' },
  longsleeve: { kragen: 'rund-duenn', saum: 'offen', aermelEnde: 'offen' },
  rollkragen: { kragen: 'roll', saum: 'offen', aermelEnde: 'offen' },
  bomber: { kragen: 'rippkragen', zu: 'rv', saum: 'rippe', aermelEnde: 'rippe', tasche: 'seiten' },
  puffer: { kragen: 'steh', zu: 'rv', saum: 'offen', aermelEnde: 'gummi', tasche: 'seiten', stepp: true },
  weste: { kragen: 'steh', zu: 'rv', saum: 'offen', tasche: 'seiten', stepp: true, ohneAermel: true },
  jeansjacke: { kragen: 'hemd', zu: 'knopf', saum: 'bund', aermelEnde: 'manschette', tasche: 'brust' },
  chore: { kragen: 'hemd', zu: 'knopf', saum: 'offen', aermelEnde: 'offen', tasche: 'aufgesetzt' },
  sherpa: { kragen: 'steh', zu: 'rv', saum: 'offen', aermelEnde: 'offen', tasche: 'aufgesetzt', fell: true },
  jacke: { kragen: 'steh', zu: 'rv', saum: 'offen', aermelEnde: 'gummi', tasche: 'seiten' },
  // Hosen: drop = wie weit der Schritt unter dem Körperschritt hängt (cm)
  hose: { hose: true, drop: 4, kordel: true },
  barrel: { hose: true, drop: 6, kordel: true, barrel: true },
  leggings: { hose: true, drop: 0.8, eng: true, hochbund: true },
  // Sport-BH: Träger, U-Ausschnitt, Unterbrustband; Sitz über die Dehnung von Band und Brustteil
  bh: { bh: true },
};
const artVon = (teil) => ARTEN[teil?.art] || ARTEN.hoodie;
// Reihenfolge zählt: „Zip-Hoodie“ vor „Hoodie“, „Puffer Weste“ vor „Puffer“, „Sweat Pull Over Hoodie“ vor „Sweat“
const ARTNAMEN = [
  [/sport-?bh|\bbh\b|\bbra\b|bustier/i, 'bh'],
  [/legging/i, 'leggings'],
  [/barrel/i, 'barrel'],
  [/hose|pants|jogger/i, 'hose'],
  [/zip/i, 'zip'],
  [/weste|gilet|vest/i, 'weste'],
  [/puffer|stepp/i, 'puffer'],
  [/bomber/i, 'bomber'],
  [/jeans|denim/i, 'jeansjacke'],
  [/chore|overshirt|hemdjacke/i, 'chore'],
  [/sherpa|teddy|fleece/i, 'sherpa'],
  [/rollkragen|turtle/i, 'rollkragen'],
  [/longsleeve|langarm/i, 'longsleeve'],
  [/hood/i, 'hoodie'],
  [/shirt|tee/i, 'shirt'],
  [/jacke|jacket|windbreaker|parka/i, 'jacke'],
  [/sweat|crew|pullover|sweater/i, 'sweater'],
];

// ---------- Figur ----------
function figur(m, teil, o) {
  const { cx, boden, k, id = 'f' } = o;
  const T = ([x, y, e]) => [cx + x * k, boden - y * k, e];
  const pfad = (l, zu = true, fill = 'none', extra = '', t = 1) =>
    `<path d="${kurve(l.map(T), zu, t)}" fill="${fill}" ${extra}/>`;
  const linie = (l, farbe, breite, extra = '') => pfad(l, false, 'none', `stroke="${farbe}" stroke-width="${r1(breite)}" stroke-linecap="round" stroke-linejoin="round" ${extra}`);
  const SW = Math.max(0.7, k * 0.5);

  const haut = '#dfd9cf';
  const hautSchatten = '#cfc7ba';
  const S = m.h;
  const hk = m.ohr * 1.78;
  const kb = m.kopfB;
  const nw = (m.hals / Math.PI) * 0.9;
  const akr2 = m.akr / 2;
  const delt2 = Math.max(m.delt / 2, akr2 + 2.2);
  const brB2 = m.brB / 2;
  const taB2 = m.taB / 2;
  const hfB2 = m.hfB / 2;
  const ru = (m.bizU / Math.PI / 2) * 0.86;
  const re = ru * 0.78;
  const rf = (m.uarmU / Math.PI / 2) * 0.86;
  const rw = (m.handgU / Math.PI / 2) * 0.98;
  const ellH = m.akrH - m.oberarm;
  const J = [-(akr2 - 1.6), m.akrH - 3.5];
  const xe = -Math.max(-J[0] + 0.6, taB2 + re + 0.2, brB2 + re * 0.5);
  const xw = -Math.max(-xe + 0.8, hfB2 + rw + 1.6, taB2 + rw + 1.0);
  const E = [xe, ellH];
  const W = [xw, m.handgH];
  const xf = lerp(xe, xw, 0.3);
  const mo = [(J[0] + xe) / 2, (J[1] + ellH) / 2];

  // Kleidungsfarben
  const farbe = o.farbe || '#c9bfae';
  const dunkel = hell(farbe) < 0.12;
  const linieF = dunkel ? mische(farbe, '#ffffff', 0.22) : mische(farbe, '#000000', 0.32);
  const schatten = dunkel ? '#000000' : mische(farbe, '#000000', 0.5);
  const tasche = mische(farbe, '#000000', dunkel ? 0.02 : 0.05);
  const hose = hell(farbe) > 0.3 ? '#2f2f31' : '#cdc8bf';
  const hoseLinie = hell(farbe) > 0.3 ? '#4a4a4d' : '#b3ada2';

  let svg = '';
  let defs = '';
  // Bodenschatten
  svg += `<ellipse cx="${r1(cx)}" cy="${r1(boden)}" rx="${r1((hfB2 + 9) * k)}" ry="${r1(1.4 * k)}" fill="#000" opacity=".07"/>`;

  // Körper (Rumpf)
  const rumpf = [
    [-nw / 2, m.c7H + 1.5],
    [-(nw / 2 + (akr2 - nw / 2) * 0.45), lerp(m.c7H, m.akrH, 0.45) + 0.6],
    [-akr2, m.akrH + 0.3],
    [-(brB2 + 0.2), m.achselH],
    [-brB2, m.brH],
    [-taB2, m.taH],
    [-((taB2 * 0.45) + hfB2 * 0.55), m.beckenH],
    [-hfB2, m.trochH],
    [-(hfB2 - 0.6), m.schrittH],
    [0, m.schrittH - 0.5, true],
  ];
  svg += pfad(rumpf.concat(spiegel(rumpf).slice(1)), true, haut);

  // Hose: Standardhose (bei Oberteilen) oder die Hose aus der Maßtabelle
  const istHose = !!(teil && artVon(teil).hose);
  const istBH = !!(teil && artVon(teil).bh);
  const kx = Math.max(hfB2 * 0.5, 7.2);
  const ax = kx - 0.5;
  const osch = (m.oschU / Math.PI / 2) * 0.95;
  const aussenKnie = Math.max(osch * 0.62 + 2.4, 8.4);
  const innenKnie = Math.max(Math.min(osch * 0.55 + 1.4, kx - 0.4), 5);
  const saumH = m.knoechelH + 2.4;
  const hb = Math.max(9.2, aussenKnie * 0.95);
  const bein = [
    [-(hfB2 * 0.96 + 0.8), m.beckenH - 1, true],
    [-(hfB2 + 1.5), m.trochH],
    [-(hfB2 + 1.1), m.schrittH - 2],
    [-(kx + aussenKnie), m.knieH],
    [-(ax + hb), saumH, true],
    [-(ax - hb * 0.92), saumH, true],
    [-(kx - innenKnie), m.knieH],
    [-Math.max(0.5, Math.min(kx - innenKnie, osch * 0.25)), m.schrittH - 4],
    [0, m.schrittH - 1.5, true],
  ];
  let schuhe = '';
  for (const s of [-1, 1]) {
    const B = (x, y) => [s * x, y];
    // Schuh
    const fb = Math.max(m.fussB + 1.6, 10.5);
    const schuh = [
      B(ax - fb / 2, 1.6, true),
      B(ax - fb / 2 - 0.3, 3.8),
      B(ax - fb * 0.4, 7.4),
      B(ax, 8.8),
      B(ax + fb * 0.4, 7.4),
      B(ax + fb / 2 + 0.3, 3.8),
      B(ax + fb / 2, 1.6, true),
    ].map(([x, y]) => [x, y]);
    schuhe += pfad(schuh, true, '#f4f3ef', `stroke="#b9b3a8" stroke-width="${r1(SW * 0.8)}"`);
    schuhe += pfad([B(ax - fb / 2 - 0.4, 1.8, true), B(ax + fb / 2 + 0.4, 1.8, true), B(ax + fb / 2 + 0.4, 0, true), B(ax - fb / 2 - 0.4, 0, true)], true, '#d9d4ca');
  }
  if (istHose) svg += schuhe + hoseZeichnen(teil, farbe, id);
  else if (istBH) {
    // Zum Sport-BH neutrale Leggings (Hochbund, bis knapp über den Knöchel)
    const bundL = hosenBund(m, ARTEN.leggings);
    svg += schuhe + hoseZeichnen({ art: 'leggings', aussenbein: (bundL - m.knoechelH - 1) / 1.08, bundhoehe: 6.5 }, hose, `${id}-l`);
  } else {
    svg += pfad(bein.concat(spiegel(bein).slice(1)), true, hose);
    for (const s of [-1, 1]) {
      const B = (x, y) => [s * x, y];
      svg += linie([B(kx + aussenKnie * 0.5, m.knieH + 4), B(kx - 1, m.knieH + 1.5), B(kx - innenKnie * 0.4, m.knieH + 2.4)], hoseLinie, SW * 0.9);
      svg += linie([B(ax + hb * 0.7, saumH + 5.5), B(ax, saumH + 3.8), B(ax - hb * 0.6, saumH + 4.6)], hoseLinie, SW * 0.9);
    }
    svg += schuhe;
  }



  // Hose aus der Maßtabelle (Foto-Fit für Hosen): Bund mit Kordel, Taschen, Saum bzw. Bündchen, Stauchung über dem Schuh
  function hoseZeichnen(teil, farbe, kennung) {
    const A = artVon(teil);
    const dunkel = hell(farbe) < 0.12;
    const linieF = dunkel ? mische(farbe, '#ffffff', 0.22) : mische(farbe, '#000000', 0.32);
    const schatten = dunkel ? '#000000' : mische(farbe, '#000000', 0.5);
    const rand = `stroke="${linieF}" stroke-width="${r1(SW)}" stroke-linejoin="round"`;
    const f = sitzHose(m, teil);
    const oben = hosenBund(m, A);
    const bh = teil.bundhoehe || (A.eng ? 6.5 : 4.5);
    const schritt = m.schrittH - A.drop;
    const stapel = Math.max(0, 3 - f.saum);
    const saumY = Math.max(f.saum, 3);
    const knoechelR = (m.knoU / Math.PI / 2) * 0.95;
    // Sichtbare Breite = Körper + Anteil des Umfang-Überschusses (das Hosenbein ist eine Röhre, kein flaches Stück Stoff)
    const ueber = (teilU, koerperU) => Math.max(0.8, ((teilU - koerperU) / Math.PI) * 0.6);
    const schenkelFlach = teil.oberschenkel || (teil.huefte ? teil.huefte * 0.6 : 32);
    const hueftFlach = teil.huefte || schenkelFlach * 1.35;
    const saumFlach = teil.hsaum || schenkelFlach * 0.72;
    const knieFlach = A.barrel ? schenkelFlach * 1.02 : lerp(schenkelFlach, saumFlach, 0.5);
    const knieKoerper = osch * 0.64;
    const wv = (A.eng ? taB2 : breiteBei(m, oben) - 0.4) + (A.eng ? 0.3 : 0.8);
    const hv = A.eng ? hfB2 + 0.35 : hfB2 + ueber(2 * hueftFlach, m.hfU);
    const tv = A.eng ? osch + 0.25 : osch + ueber(2 * schenkelFlach, m.oschU);
    const knieHalb = A.eng ? knieKoerper + 0.3 : knieKoerper + ueber(2 * knieFlach, m.oschU * 0.66);
    const saumHalb = A.eng ? knoechelR + 0.35 : knoechelR + ueber(2 * saumFlach, m.knoU);
    const bund = !A.eng && teil.hsaum && teil.hsaum * 2 < m.wadeU * 1.15;
    const xc = hv * 0.5;
    const kxH = Math.max(kx, knieHalb * 0.92 + 0.4);
    const axH = Math.max(ax, saumHalb + 0.5);
    const bein = [
      [-wv, oben, true],
      [-lerp(wv, hv, 0.65), lerp(oben, m.trochH, 0.55)],
      [-hv, m.trochH],
      [-(xc + tv), schritt - 3],
      [-(kxH + knieHalb), m.knieH],
      [-(axH + saumHalb), saumY + (stapel > 0 ? 0.8 : 0), true],
      [-(axH - saumHalb), saumY, true],
      [-Math.max(0.35, kxH - knieHalb * 0.9), m.knieH],
      [-Math.max(0.35, xc - tv * 0.95), schritt - 4],
      [0, schritt, true],
    ];
    const umriss = bein.concat(spiegel(bein).slice(1));
    defs += `<clipPath id="${kennung}-h"><path d="${kurve(umriss.map(T), true)}"/></clipPath>`;
    let o = pfad(umriss, true, farbe, rand);
    let innen = '';
    for (const s of [-1, 1]) {
      const B = (x, y) => [s * x, y];
      if (A.eng) {
        innen += linie([B(xc + tv * 0.15, schritt - 6), B(kxH + knieHalb * 0.2, m.knieH + 2), B(axH + saumHalb * 0.1, saumY + 8)], '#ffffff', SW * 2.2, 'opacity=".16"');
        continue;
      }
      // Schatten an der Beininnenseite trennt die Beine optisch
      innen += pfad([B(0.2, schritt - 1), B(Math.max(0.6, xc - tv * 0.95) + 2.6, schritt - 6), B(Math.max(0.6, kxH - knieHalb * 0.9) + 2.4, m.knieH), B(Math.max(0.6, axH - saumHalb) + 2.2, saumY + 1), B(Math.max(0.6, axH - saumHalb) - 0.2, saumY), B(0.2, m.knieH)], true, schatten, 'opacity=".1"');
      // Seitentasche, Kniefalten
      innen += linie([B(wv * 0.72, oben - bh - 0.3), B(lerp(wv, hv, 0.55) + 0.3, oben - bh - 8), B(hv - 0.8, oben - bh - 15)], linieF, SW * 0.9);
      innen += linie([B(kxH + knieHalb * 0.55, m.knieH + 4), B(kxH, m.knieH + 1.8), B(kxH - knieHalb * 0.45, m.knieH + 3)], linieF, SW * 0.75, 'opacity=".55"');
      innen += linie([B(kxH + knieHalb * 0.4, m.knieH - 3), B(kxH - knieHalb * 0.1, m.knieH - 4.2)], linieF, SW * 0.7, 'opacity=".4"');
      if (A.barrel) innen += linie([B(xc + tv * 0.9, schritt - 8), B(kxH + knieHalb * 0.75, m.knieH), B(axH + saumHalb * 0.8, saumY + 6)], linieF, SW * 0.8, 'opacity=".6"');
      // Stauchung über dem Schuh
      const falten = Math.min(4, Math.ceil(stapel / 2.2));
      for (let i = 0; i < falten; i++) {
        const y = saumY + (bund ? 7 : 2.6) + i * 2.7;
        innen += linie([B(axH + saumHalb * 0.95, y + 1.2), B(axH + saumHalb * 0.1, y - 0.4), B(axH - saumHalb * 0.85, y + 1)], linieF, SW * 0.75, 'opacity=".55"');
      }
    }
    if (!A.eng) innen += linie([[0, oben - bh], [0.4, lerp(oben - bh, schritt, 0.6)], [0, schritt + 0.6]], linieF, SW * 0.7, 'opacity=".5"');
    o += `<g clip-path="url(#${kennung}-h)">${innen}</g>`;
    // Bündchen am Saum (Jogger)
    if (bund)
      for (const s of [-1, 1]) {
        const B = (x, y) => [s * x, y];
        o += pfad([B(axH - saumHalb, saumY + 6, true), B(axH + saumHalb, saumY + 6.4, true), B(axH + saumHalb, saumY + 0.8, true), B(axH - saumHalb, saumY, true)], true, mische(farbe, '#000000', dunkel ? 0 : 0.05), rand);
        let rl = '';
        for (let t = -saumHalb + 1; t < saumHalb - 0.5; t += 1.15) {
          const a = T(B(axH + t, saumY + 5.6));
          rl += `M${r1(a[0])} ${r1(a[1])}V${r1(T(B(axH + t, saumY + 0.7))[1])}`;
        }
        o += `<path d="${rl}" stroke="${linieF}" stroke-width="${r1(SW * 0.45)}" opacity=".35"/>`;
      }
    // Bund mit Gummizug und Kordel
    o += pfad([[-wv, oben, true], [wv, oben, true], [wv + 0.1, oben - bh, true], [-wv - 0.1, oben - bh, true]], true, mische(farbe, '#000000', dunkel ? 0 : 0.05), rand);
    if (A.eng) o += linie([[-wv + 0.6, oben - bh + 1.2], [wv - 0.6, oben - bh + 1.2]], linieF, SW * 0.6, `stroke-dasharray="${r1(k * 0.7)} ${r1(k * 0.5)}" opacity=".6"`);
    else {
      let rl = '';
      for (let x = -wv + 1; x < wv - 0.5; x += 1.6) {
        const a = T([x, oben - 0.6]);
        const b = T([x + 0.3, oben - bh * 0.5]);
        const c = T([x, oben - bh + 0.6]);
        rl += `M${r1(a[0])} ${r1(a[1])}L${r1(b[0])} ${r1(b[1])}L${r1(c[0])} ${r1(c[1])}`;
      }
      o += `<path d="${rl}" fill="none" stroke="${linieF}" stroke-width="${r1(SW * 0.45)}" opacity=".35"/>`;
    }
    if (A.kordel) {
      const kordel = mische(farbe, '#ffffff', dunkel ? 0.35 : 0.5);
      const spitze = dunkel ? '#8a8a8a' : '#9c9a94';
      for (const s of [-1, 1]) {
        const k0 = [s * 1.4, oben - bh * 0.45];
        const k1 = [s * 2.2, oben - bh - 6];
        const k2 = [s * 2.6, oben - bh - 13];
        o += linie([k0, k1, k2], linieF, SW * 2.2) + linie([k0, k1, k2], kordel, SW * 1.4) + linie([k2, [s * 2.65, oben - bh - 15.5]], spitze, SW * 2);
      }
    }
    return o;
  }

  // Arm-Umriss (linke Seite, x negativ)
  const armAussen = [
    [m.akrH - 7, -delt2],
    [mo[1], mo[0] - ru],
    [ellH, xe - re],
    [ellH - 7, xf - rf],
    [m.handgH + 1, xw - rw],
  ];
  const armInnen = [
    [m.achselH - 1, -(brB2 - 0.8)],
    [mo[1] + 3, mo[0] + ru * 0.8],
    [ellH + 0.5, xe + re * 0.85],
    [ellH - 7, xf + rf * 0.85],
    [m.handgH + 1, xw + rw],
  ];
  const bei = (tab, y) => {
    if (y >= tab[0][0]) return tab[0][1];
    for (let i = 1; i < tab.length; i++)
      if (y >= tab[i][0]) return lerp(tab[i][1], tab[i - 1][1], (y - tab[i][0]) / (tab[i - 1][0] - tab[i][0]));
    return tab[tab.length - 1][1];
  };
  const achseBei = (y) => (bei(armAussen, y) + bei(armInnen, y)) / 2;
  const armPunkte = [
    [-(akr2 - 0.8), m.akrH + 1.4],
    [-(delt2 - 0.5), m.akrH - 2.5],
    ...armAussen.map(([y, x]) => [x, y]),
    ...armInnen.slice().reverse().map(([y, x]) => [x, y]),
  ];
  const handPunkte = () => {
    const d = norm([0.07, -1]);
    const nn = [d[1], -d[0]];
    const hl = m.handL;
    return [
      plus(W, nn, rw),
      plus(plus(W, d, hl * 0.36), nn, rw * 1.08),
      plus(plus(W, d, hl * 0.8), nn, rw * 0.7),
      plus(W, d, hl),
      plus(plus(W, d, hl * 0.74), nn, -rw * 0.78),
      plus(plus(W, d, hl * 0.3), nn, -rw * 1.18),
      plus(W, nn, -rw),
    ];
  };

  // Kleidungsstück – je Ebene ein Aufruf (unter einer Weste liegt ein schlichtes Langarmshirt)
  function kleidung(teil, farbe, kennung) {
    const A = artVon(teil);
    const dunkel = hell(farbe) < 0.12;
    const linieF = dunkel ? mische(farbe, '#ffffff', 0.22) : mische(farbe, '#000000', 0.32);
    const schatten = dunkel ? '#000000' : mische(farbe, '#000000', 0.5);
    const tasche = mische(farbe, '#000000', dunkel ? 0.02 : 0.05);
    const zier = mische(farbe, dunkel ? '#ffffff' : '#000000', dunkel ? 0.42 : 0.5);
    const rand = `stroke="${linieF}" stroke-width="${r1(SW)}" stroke-linejoin="round"`;
    const aus = { hinten: '', rumpf: '', aermel: '', kragenHinten: '', vorn: '', armOben: Infinity };
    const rippe = A.saum === 'rippe' ? 6 : A.saum === 'bund' ? 4.5 : 0;
    const schoppt = A.saum === 'rippe' && !(teil.bund >= teil.brust * 0.95);
    const stauchen = A.aermelEnde === 'rippe' || A.aermelEnde === 'gummi';
    const ohne = !!A.ohneAermel;
    const hps = m.c7H + 1.8;
    const nwH = nw / 2 + 0.7;
    const nfY = hps - ({ kapuze: 8, hemd: 7, rippkragen: 5, steh: 2.5, roll: 2.5, 'rund-duenn': 6.5 }[A.kragen] ?? 6);
    const ss2 = teil.schulter / 2;
    const fallend = !ohne && ss2 > akr2 + 0.6;
    const sx = ohne ? -(akr2 + 0.4) : fallend ? -Math.min(ss2, delt2 + 1.3) : -ss2;
    const sy = ohne ? m.akrH + 0.8 : fallend ? m.akrH - (ss2 - akr2) * 0.9 : m.akrH + 0.9 + (akr2 - ss2) * 0.25;
    let pv = Math.max(brB2 + 1.2, teil.brust * 0.42);
    const armloch = Math.max(19, teil.brust * 0.36);
    const uy = Math.min(sy - armloch * 0.8, m.achselH - 2);
    const saum = hps - teil.laenge + (schoppt ? 3 : 0);
    let ph = Math.max(pv * 0.99, breiteBei(m, saum + rippe + 5) + 1.4);

    // Kapuze liegt hinten auf den Schultern
    if (A.kragen === 'kapuze') {
      const kap = [[-(nwH + 6.2), hps - 3], [-(nwH + 5.4), hps + 3.2], [-(nwH + 2.1), hps + 7.6], [0, hps + 8.8]];
      aus.hinten = pfad(kap.concat(spiegel(kap).slice(1)), true, mische(farbe, '#000000', dunkel ? 0 : 0.12), rand);
    }

    // Ärmel-Geometrie (linke Seite)
    const flachBizeps = teil.brust * 0.36;
    const sichtB = Math.max(2 * ru + 2.5, flachBizeps * 0.8);
    const mehrB = sichtB - 2 * ru;
    const oe = Math.min(mehrB * 0.35, 3.5);
    const ie = mehrB - oe;
    const sichtE = Math.max(2 * re + 2.5, sichtB * 0.86);
    const mehrE = sichtE - 2 * re;
    const oeE = Math.min(mehrE * 0.35, 3);
    const ieE = mehrE - oeE;
    const kurz = !ohne && teil.aermel < 32;
    const ext = ss2 + teil.aermel - (m.akr / 2 + 2 + m.armA) - (stauchen ? 2 : 0);
    const dUnten = norm([W[0] - E[0], W[1] - E[1]]);
    const handRicht = norm([0.07, -1]);
    const uaY = Math.min(uy, m.achselH - 1);
    const aussenOben = -Math.max(-bei(armAussen, mo[1]) + oe, -sx - 1);
    if (!ohne) {
      pv = Math.min(pv, -aussenOben - 0.6);
      ph = Math.max(Math.min(ph, -aussenOben + 1.5), breiteBei(m, saum + rippe + 5) + 1.4);
    }
    const bandLaenge = { rippe: 6.5, manschette: 5, gummi: 2 }[A.aermelEnde] || 1.5;

    let au = null;
    let innenX = -(brB2 - 2);
    let naht = null;
    let ende, oben, richt, cb = 0, stau = 0, sc = 0;
    if (ohne) {
      aus.armOben = sy - 1;
    } else if (kurz) {
      const ye = sy - teil.aermel * 0.93;
      const ax = achseBei(ye);
      const breit = Math.max(2 * ru * 0.95 + 3, flachBizeps * 0.85);
      const aussen = -Math.max(-ax + breit * 0.45, -sx - 0.5);
      const innen = -Math.max(-ax - breit * 0.55, brB2 - 1.5);
      const UA = [-Math.max(-innen + 0.3, brB2 - 0.8), Math.max(uaY, ye + 3)];
      const CP = [UA[0] - (UA[0] - sx) * 0.18, lerp(UA[1], sy, 0.72)];
      au = [[sx, sy, true], [-Math.max(-bei(armAussen, lerp(sy, ye, 0.5)) + oe * 0.7, -sx - 0.8), lerp(sy, ye, 0.5)], [aussen, ye, true], [innen, ye, true], UA, CP];
      naht = [[sx, sy], CP, UA];
      innenX = innen;
      aus.armOben = ye + 0.6;
    } else {
      if (ext >= 0) {
        ende = plus(W, handRicht, stauchen ? ext - Math.min(ext, 7) * 0.55 : ext);
        richt = handRicht;
      } else {
        ende = plus(W, dUnten, ext);
        richt = dUnten;
      }
      oben = plus(ende, richt, -bandLaenge);
      stau = stauchen && ext > 1 ? Math.min(ext, 9) * 0.24 : 0;
      sc = Math.max(rw + 2.0, sichtB * 0.29) + stau;
      cb = Math.max(rw + 0.9, A.aermelEnde === 'rippe' ? 4.6 : sc * 0.92);
      const n = [richt[1], -richt[0]];
      const aussenEll = -Math.max(-(xe - re) + oeE, -sx - 2.5);
      const innenEll = -Math.max(-(xe + re * 0.85) - ieE, breiteBei(m, ellH) - 2.2);
      const UA = [-Math.max(-(mo[0] + ru * 0.8) - ie * 0.6, brB2 - 0.8), uaY];
      const innenMitte = [lerp(innenEll, UA[0], 0.5) + 0.4, lerp(ellH, uaY, 0.5)];
      const CP = [UA[0] - (UA[0] - sx) * 0.18, lerp(uaY, sy, 0.72)];
      au = [[sx, sy, true], [aussenOben, mo[1]], [aussenEll, ellH], plus(oben, n, sc), [...plus(oben, n, cb * 1.02), true], [...plus(oben, n, -cb * 1.02), true], plus(oben, n, -sc), [innenEll, ellH + 0.5], innenMitte, UA, CP];
      naht = [[sx, sy], CP, UA];
      innenX = innenEll;
      aus.armOben = oben[1] + 0.6;
    }

    // Vorderteil
    const rb = A.saum === 'rippe' ? Math.max(breiteBei(m, saum) + 0.8, (teil.bund || ph * 1.7) * 0.4) : A.saum === 'bund' ? Math.max(breiteBei(m, saum) + 0.8, ph * 0.96) : ph;
    const vorne = A.kragen === 'hemd' ? [[0, nfY, true], [-(nwH * 0.5), lerp(nfY, hps, 0.55)], [-nwH, hps]] : [[0, nfY], [-(nwH * 0.62), nfY + 2.8], [-nwH, hps]];
    vorne.push([-lerp(nwH, akr2, 0.5), lerp(hps, m.akrH + 1.2, 0.5) + 0.7]);
    if (fallend) vorne.push([-(akr2 + 0.7), m.akrH + 1.3]);
    if (ohne) vorne.push([sx, sy, true], [-(brB2 + 1.4), m.achselH - 3.5], [-pv, m.achselH - 9]);
    else vorne.push([sx, sy, true], [-pv, uy]);
    vorne.push([-ph, saum + rippe + 7]);
    if (rippe) vorne.push([-(rb + (schoppt ? 1.6 : 0.2)), saum + rippe + 0.6], [-rb, saum + rippe, true]);
    else vorne.push([-ph, saum + 1.2], [-ph + 0.2, saum, true]);
    const vorneZu = vorne.concat(spiegel(vorne).slice(0, -1));
    defs += `<clipPath id="${kennung}-v"><path d="${kurve(vorneZu.map(T), true)}"/></clipPath>`;
    aus.rumpf += pfad(vorneZu, true, farbe, rand);

    // Schatten, Falten, Taschen, Steppung im Vorderteil
    let innen = '';
    if (A.fell) innen += fellFlaeche([[-ph - 6, hps + 3], [ph + 6, saum]], farbe, kennung);
    if (!ohne)
      for (const s of [-1, 1]) {
        const ix = s * Math.max(-innenX, brB2 - 2);
        const bis = kurz ? Math.max(aus.armOben + 2, saum + rippe + 5) : saum + rippe + 5;
        innen += pfad([[ix, uy + 1], [ix - s * 2.6, uy - 5], [ix - s * 2, bis], [ix + s * 1.5, bis]], true, schatten, 'opacity=".12"');
        if (!kurz && !A.stepp) innen += linie([[ix - s * 1.3, uy - 4], [ix - s * 2.3, lerp(uy, saum, 0.5)], [ix - s * 2.1, saum + rippe + 9]], linieF, SW * 0.75, 'opacity=".45"');
      }
    innen += pfad([[-nwH - 1, hps - 1.2], [0, nfY - 2.6], [nwH + 1, hps - 1.2], [nwH + 1, hps + 2], [-nwH - 1, hps + 2]], true, schatten, 'opacity=".12"');
    if (A.stepp)
      for (let y = saum + rippe + 7.5; y < hps - 4; y += 8.5)
        innen += linie([[-ph - 3, y + 0.6], [-ph * 0.45, y - 0.3], [0, y - 0.6], [ph * 0.45, y - 0.3], [ph + 3, y + 0.6]], linieF, SW * 0.8, 'opacity=".55"');
    if (schoppt) {
      innen += pfad([[-ph - 2, saum + rippe + 2], [ph + 2, saum + rippe + 2], [ph + 2, saum + rippe], [-ph - 2, saum + rippe]], true, schatten, 'opacity=".14"');
      for (const s of [-1, 1])
        for (const t of [0.3, 0.62, 0.9])
          innen += linie([[s * rb * t - s * 1.4, saum + rippe + 4], [s * rb * t, saum + rippe + 1.3], [s * rb * t + s * 1.5, saum + rippe + 3.4]], linieF, SW * 0.7, 'opacity=".45"');
    }
    const unten = saum + rippe;
    if (A.tasche === 'kaenguru') {
      const pyB = unten + 1.4;
      const pyT = pyB + Math.min(24, (uy - pyB) * 0.62);
      const pt = Math.min(pv * 0.5, 15);
      const pb = Math.min(ph * 0.72, 20);
      if (pyT - pyB > 12) {
        const ta = [[-pt, pyT, true], [pt, pyT, true], [pt + (pb - pt) * 0.3, lerp(pyT, pyB, 0.5)], [pb, pyB + 2.2], [pb, pyB, true], [-pb, pyB, true], [-pb, pyB + 2.2], [-pt - (pb - pt) * 0.3, lerp(pyT, pyB, 0.5)]];
        innen += pfad(ta, true, tasche, `stroke="${linieF}" stroke-width="${r1(SW * 0.9)}"`);
        innen += linie([[-pt + 1, pyT - 1.1], [pt - 1, pyT - 1.1]], linieF, SW * 0.6, `stroke-dasharray="${r1(k * 0.9)} ${r1(k * 0.7)}" opacity=".7"`);
        for (const s of [-1, 1])
          innen += pfad([[s * pt, pyT], [s * (pt + (pb - pt) * 0.3), lerp(pyT, pyB, 0.5)], [s * pb, pyB + 2.2], [s * (pb - 1.6), pyB + 2.6], [s * (pt + (pb - pt) * 0.15 - 1.2), lerp(pyT, pyB, 0.5)], [s * (pt - 0.6), pyT - 0.4]], true, schatten, 'opacity=".16"');
      }
    } else if (A.tasche === 'seiten') {
      for (const s of [-1, 1]) {
        const a = [s * ph * 0.44, unten + 18];
        const b = [s * ph * 0.64, unten + 5];
        innen += pfad([a, b, [b[0] - s * 1.3, b[1] - 0.2], [a[0] - s * 1.3, a[1] - 0.2]], true, schatten, 'opacity=".22"');
        innen += linie([a, b], linieF, SW * 0.9);
      }
    } else if (A.tasche === 'aufgesetzt') {
      for (const s of [-1, 1]) {
        const xi = s * ph * 0.16;
        const xa = s * Math.min(ph * 0.66, ph - 2.5);
        const yo = unten + Math.min(21, (uy - unten) * 0.55);
        const yu = unten + 4;
        innen += pfad([[xi, yo, true], [xa, yo, true], [xa, yu + 1.2], [xa - s * 1.2, yu, true], [xi + s * 1.2, yu, true], [xi, yu + 1.2]], true, tasche, `stroke="${linieF}" stroke-width="${r1(SW * 0.9)}"`);
        innen += linie([[xi + s * 0.8, yo - 1.4], [xa - s * 0.8, yo - 1.4]], linieF, SW * 0.6, `stroke-dasharray="${r1(k * 0.8)} ${r1(k * 0.6)}" opacity=".7"`);
      }
    } else if (A.tasche === 'brust') {
      for (const s of [-1, 1]) {
        const xm = s * Math.min(pv * 0.46, pv - 6);
        const yo = m.brH + 7;
        const kasten = [[xm - 5.2, yo, true], [xm + 5.2, yo, true], [xm + 5.2, yo - 11, true], [xm - 5.2, yo - 11, true]];
        innen += pfad(kasten, true, tasche, `stroke="${linieF}" stroke-width="${r1(SW * 0.9)}"`);
        innen += pfad([[xm - 5.6, yo + 0.4, true], [xm + 5.6, yo + 0.4, true], [xm + 5.6, yo - 3.4], [xm, yo - 5, true], [xm - 5.6, yo - 3.4]], true, farbe, `stroke="${linieF}" stroke-width="${r1(SW * 0.9)}"`);
        const kn = T([xm, yo - 3.8]);
        innen += `<circle cx="${r1(kn[0])}" cy="${r1(kn[1])}" r="${r1(0.6 * k)}" fill="${zier}"/>`;
      }
    }
    aus.rumpf += `<g clip-path="url(#${kennung}-v)">${innen}</g>`;

    // Saumbündchen bzw. Bund
    if (rippe) {
      const rp = [[-rb, saum + rippe, true], [rb, saum + rippe, true], [rb, saum + 0.8], [rb - 0.6, saum, true], [-rb + 0.6, saum, true], [-rb, saum + 0.8]];
      aus.rumpf += pfad(rp, true, mische(farbe, '#000000', dunkel ? 0 : 0.04), rand);
      if (A.saum === 'rippe') {
        let rl = '';
        for (let x = -rb + 1.1; x < rb - 0.6; x += 1.15) {
          const a = T([x, saum + rippe - 0.5]);
          rl += `M${r1(a[0])} ${r1(a[1])}V${r1(T([x, saum + 0.6])[1])}`;
        }
        aus.rumpf += `<path d="${rl}" stroke="${linieF}" stroke-width="${r1(SW * 0.45)}" opacity=".35"/>`;
      } else aus.rumpf += linie([[-rb + 0.8, saum + rippe - 1.2], [rb - 0.8, saum + rippe - 1.2]], linieF, SW * 0.6, `stroke-dasharray="${r1(k * 0.8)} ${r1(k * 0.6)}" opacity=".7"`);
    }

    // Verschluss
    const zuOben = A.kragen === 'steh' || A.kragen === 'roll' ? hps - 2.6 : nfY;
    if (A.zu === 'rv') {
      aus.rumpf += linie([[0, zuOben], [0, saum + 0.4]], zier, SW * 1.5);
      aus.rumpf += linie([[0, zuOben], [0, saum + 0.4]], mische(zier, '#ffffff', 0.35), SW * 0.5, `stroke-dasharray="${r1(k * 0.35)} ${r1(k * 0.35)}"`);
    } else if (A.zu === 'knopf') {
      aus.rumpf += linie([[-1, nfY - 0.4], [-1, saum + 0.4]], linieF, SW * 0.8) + linie([[1, nfY], [1, saum + 0.4]], linieF, SW * 0.6, 'opacity=".6"');
      const anzahl = 5;
      for (let i = 0; i < anzahl; i++) {
        const y = lerp(nfY - 1.5, saum + rippe + 3.5, i / (anzahl - 1));
        const p = T([0, y]);
        aus.rumpf += `<circle cx="${r1(p[0])}" cy="${r1(p[1])}" r="${r1(0.62 * k)}" fill="${zier}"/>`;
      }
    }

    // Ärmel (beide Seiten)
    if (au)
      for (const s of [-1, 1]) {
        const X = ([x, y, e]) => [s < 0 ? x : -x, y, e];
        const form = au.map(X);
        aus.aermel += pfad(form, true, farbe, rand);
        if (A.fell || A.stepp) {
          defs += `<clipPath id="${kennung}-a${s}"><path d="${kurve(form.map(T), true)}"/></clipPath>`;
          let deko = '';
          if (A.fell) deko += fellFlaeche([[-120, hps + 4], [120, (oben || [0, saum])[1] - 2]], farbe, kennung);
          if (A.stepp && !kurz) {
            const lang = Math.hypot(oben[0] - sx, oben[1] - sy);
            const d = norm([oben[0] - sx, oben[1] - sy]);
            const n = [d[1], -d[0]];
            for (let t = 8; t < lang - 2; t += 8) {
              const p = plus([sx, sy], d, t);
              deko += linie([plus(p, n, 16), plus(plus(p, n, 0), d, 0.6), plus(p, n, -16)].map(X), linieF, SW * 0.8, 'opacity=".55"');
            }
          }
          aus.aermel += `<g clip-path="url(#${kennung}-a${s})">${deko}</g>`;
        }
        aus.aermel += linie(naht.map(X), linieF, SW * 0.8, 'opacity=".7"');
        if (kurz) {
          aus.aermel += linie([[au[2][0] + 0.3, au[2][1] + 2], [au[3][0] - 0.3, au[3][1] + 2]].map(X), linieF, SW * 0.6, `stroke-dasharray="${r1(k * 0.8)} ${r1(k * 0.6)}" opacity=".6"`);
          continue;
        }
        const n = [richt[1], -richt[0]];
        if (!A.stepp) {
          aus.aermel += linie([[au[2][0] + 1.5, ellH + 3], [lerp(au[2][0], innenX, 0.5), ellH + 0.8], [innenX - 1.2, ellH + 2.2]].map(X), linieF, SW * 0.75, 'opacity=".5"');
          aus.aermel += linie([[au[1][0] + 2, mo[1] + 5], [au[1][0] + 3, lerp(mo[1], ellH, 0.6)], [au[2][0] + 2.4, ellH + 1.5]].map(X), linieF, SW * 0.7, 'opacity=".35"');
        }
        if (stau > 0.4)
          for (const t of [2.2, 4.4, 6.6].slice(0, Math.ceil(stau / 0.8)))
            aus.aermel += linie([plus(plus(oben, richt, -t), n, sc * 0.9), plus(plus(oben, richt, -t - 1.3), n, 0), plus(plus(oben, richt, -t - 0.2), n, -sc * 0.72)].map(X), linieF, SW * 0.75, 'opacity=".5"');
        const bp = [[...plus(oben, n, cb), true], plus(plus(ende, n, cb * 0.96), richt, -0.5), plus(ende, n, cb * 0.5), plus(ende, n, -cb * 0.5), plus(plus(ende, n, -cb * 0.96), richt, -0.5), [...plus(oben, n, -cb), true]];
        if (A.aermelEnde === 'rippe' || A.aermelEnde === 'manschette') {
          aus.aermel += pfad(bp.map(X), true, mische(farbe, '#000000', dunkel ? 0 : 0.04), rand);
          if (A.aermelEnde === 'rippe') {
            let rl = '';
            for (let t = -cb + 1; t < cb - 0.6; t += 1.15) {
              const a = T(X(plus(plus(oben, n, t), richt, 0.6)));
              const b = T(X(plus(plus(ende, n, t * 0.94), richt, -0.8)));
              rl += `M${r1(a[0])} ${r1(a[1])}L${r1(b[0])} ${r1(b[1])}`;
            }
            aus.aermel += `<path d="${rl}" stroke="${linieF}" stroke-width="${r1(SW * 0.45)}" opacity=".35"/>`;
          } else {
            const kn = T(X(plus(plus(oben, richt, bandLaenge / 2), n, cb * 0.55)));
            aus.aermel += `<circle cx="${r1(kn[0])}" cy="${r1(kn[1])}" r="${r1(0.55 * k)}" fill="${zier}"/>`;
          }
        } else aus.aermel += linie([plus(oben, n, sc * 0.95), plus(oben, n, -sc * 0.95)].map(X), linieF, SW * 0.7, 'opacity=".6"');
      }

    // Kragen
    if (A.kragen === 'kapuze') {
      const a = [[-(nwH + 0.4), hps - 0.6], [-(nwH * 0.62), nfY + 2.2], [0, nfY - 0.4]];
      const i = [[0, nfY + 2.6], [-(nwH * 0.5), nfY + 4.8], [-(nwH - 1.1), hps + 2.4]];
      aus.vorn += pfad(a.concat(spiegel(a).slice(1), spiegel(i), i), true, farbe, rand);
      const kordel = mische(farbe, '#ffffff', dunkel ? 0.35 : 0.5);
      const spitze = dunkel ? '#8a8a8a' : '#9c9a94';
      if (A.kordel)
        for (const s of [-1, 1]) {
          const k0 = [s * 2.6, nfY + 0.8];
          const k1 = [s * 3.1, nfY - 10];
          const k2 = [s * 2.7, nfY - 19];
          aus.vorn += linie([k0, k1, k2], linieF, SW * 2.4) + linie([k0, k1, k2], kordel, SW * 1.5) + linie([k2, [s * 2.65, nfY - 21.8]], spitze, SW * 2.2);
        }
    } else if (A.kragen === 'roll' || A.kragen === 'steh') {
      const hoch = A.kragen === 'roll' ? 7 : 5.6;
      const b2 = nw / 2 + (A.kragen === 'roll' ? 1.5 : 1.9);
      const form = [[-b2, hps - 1.4, true], [-(b2 - 0.3), hps + hoch - 0.6], [0, hps + hoch], [b2 - 0.3, hps + hoch - 0.6], [b2, hps - 1.4, true], [0, hps - 2.6]];
      aus.vorn += pfad(form, true, farbe, rand);
      if (A.kragen === 'roll') aus.vorn += linie([[-(b2 - 0.2), hps + 3.4], [0, hps + 2.6], [b2 - 0.2, hps + 3.4]], linieF, SW * 0.8, 'opacity=".7"');
      else {
        const p = T([0, hps + hoch - 0.4]);
        aus.vorn += `<ellipse cx="${r1(p[0])}" cy="${r1(p[1])}" rx="${r1((b2 - 0.5) * k)}" ry="${r1(0.8 * k)}" fill="${schatten}" opacity=".3"/>`;
        if (A.zu === 'rv') {
          aus.vorn += linie([[0, hps + hoch - 0.3], [0, hps - 2.6]], zier, SW * 1.5);
          const z = T([0.9, hps + hoch - 1.6]);
          aus.vorn += `<rect x="${r1(z[0] - 0.5 * k)}" y="${r1(z[1])}" width="${r1(1.1 * k)}" height="${r1(2.6 * k)}" rx="${r1(0.3 * k)}" fill="${zier}"/>`;
        }
      }
    } else if (A.kragen === 'hemd') {
      const s2 = nw / 2 + 1.5;
      aus.kragenHinten += pfad([[-s2, hps - 1.2, true], [-(s2 - 0.4), hps + 3.4], [0, hps + 4], [s2 - 0.4, hps + 3.4], [s2, hps - 1.2, true]], true, mische(farbe, '#000000', dunkel ? 0 : 0.08), rand);
      for (const s of [-1, 1]) {
        const blatt = [[s * (nw / 2 + 1.0), hps + 1.4], [s * (nwH + 5.0), hps - 4.6], [s * (nwH + 3.4), hps - 8.4, true], [s * 0.9, hps - 6.6, true], [s * 0.6, hps - 2]];
        aus.vorn += pfad(blatt, true, farbe, rand);
      }
      const kn = T([0, hps - 7.6]);
      aus.vorn += `<circle cx="${r1(kn[0])}" cy="${r1(kn[1])}" r="${r1(0.6 * k)}" fill="${zier}"/>`;
    } else {
      const tief = A.kragen === 'rund-duenn' ? 1.6 : A.kragen === 'rippkragen' ? 3.4 : 2.2;
      const a = [[-(nwH + 0.3), hps - 0.4], [-(nwH * 0.6), nfY + 1.4], [0, nfY]];
      const i = [[0, nfY + tief], [-(nwH * 0.62), nfY + 1.4 + tief], [-(nwH - 0.5), hps - 0.4 + tief * 0.7]];
      aus.vorn += pfad(a.concat(spiegel(a).slice(1), spiegel(i), i), true, mische(farbe, '#000000', 0.04), rand);
      if (A.kragen === 'rippkragen') {
        for (const t of [-0.8, -0.55, -0.3, 0.3, 0.55, 0.8]) {
          const x = t * nwH;
          aus.vorn += linie([[x, lerp(nfY, hps, Math.abs(t)) - 0.2], [x * 0.96, lerp(nfY, hps, Math.abs(t)) + tief * 0.8]], linieF, SW * 0.5, 'opacity=".45"');
        }
        if (A.zu === 'rv') aus.vorn += linie([[0, nfY + tief], [0, nfY - 0.2]], zier, SW * 1.5);
      }
    }
    return aus;
  }
  // Sport-BH: breite Träger, runder Ausschnitt, Unterbrustband mit Gummi; die Arme bleiben frei. Ein zu lockeres Band
  // steht etwas ab, ein sehr festes zeigt Zugfalten.
  function bhZeichnen(teil, farbe, kennung) {
    const dunkel = hell(farbe) < 0.12;
    const linieF = dunkel ? mische(farbe, '#ffffff', 0.22) : mische(farbe, '#000000', 0.32);
    const schatten = dunkel ? '#000000' : mische(farbe, '#000000', 0.5);
    const rand = `stroke="${linieF}" stroke-width="${r1(SW)}" stroke-linejoin="round"`;
    const aus = { hinten: '', rumpf: '', aermel: '', kragenHinten: '', vorn: '', armOben: Infinity };
    const f = sitzBH(m, teil);
    const hps = m.c7H + 1.8;
    const nwH = nw / 2 + 0.7;
    const tr = 3.4;
    const bandU = m.brH - (m.bau === 'd' ? 8.5 : 6.5);
    const bandO = bandU + 4.8;
    const auf = f.band && f.band < 1 ? (1 - f.band) * 5 : 0;
    const seite = (y) => breiteBei(m, y) + 0.3;
    const halb = [
      [0, m.brH + 5.2],
      [-(nwH * 0.8), m.brH + 9],
      [-(nwH + 0.6), hps - 3.4],
      [-(nwH + 0.9), hps - 0.7, true],
      [-(nwH + 0.9 + tr), hps - 1.5, true],
      [-(nwH + 1.3 + tr), lerp(hps, m.achselH, 0.5)],
      [-(brB2 - 1.6), m.achselH + 0.6],
      [-seite(m.achselH - 3.2), m.achselH - 3.2],
      [-seite(m.brH), m.brH],
      [-(seite(bandO) + auf), bandO],
      [-(seite(bandU) + auf), bandU, true],
      [0, bandU - 0.2],
    ];
    const umriss = halb.concat(spiegel(halb).slice(1, -1));
    defs += `<clipPath id="${kennung}-b"><path d="${kurve(umriss.map(T), true)}"/></clipPath>`;
    aus.rumpf += pfad(umriss, true, farbe, rand);
    // Schatten unter der Brust und an den Seiten, Wölbung der Cups, Mittelnaht
    let innen = pfad([[-seite(bandO) - 2, bandO + 2.6], [0, bandO + 1.2], [seite(bandO) + 2, bandO + 2.6], [seite(bandO) + 2, bandO - 1], [-seite(bandO) - 2, bandO - 1]], true, schatten, 'opacity=".14"');
    for (const s of [-1, 1]) {
      innen += linie([[s * nwH * 0.7, m.brH + 8.2], [s * brB2 * 0.5, m.brH + 3.6], [s * (brB2 - 1.2), m.brH + 5.4]], linieF, SW * 0.7, 'opacity=".45"');
      innen += pfad([[s * (brB2 - 1), m.achselH - 2], [s * (brB2 - 3.2), m.brH + 2], [s * (brB2 - 2.4), bandO + 1], [s * (brB2 + 1), bandO + 1], [s * (brB2 + 1), m.achselH - 2]], true, schatten, 'opacity=".1"');
    }
    innen += linie([[0, m.brH + 5], [0, bandO + 0.4]], linieF, SW * 0.6, 'opacity=".4"');
    aus.rumpf += `<g clip-path="url(#${kennung}-b)">${innen}</g>`;
    // Unterbrustband mit Gummizug
    const bo = seite(bandO) + auf;
    const bu = seite(bandU) + auf;
    aus.rumpf += pfad([[-bo, bandO, true], [bo, bandO, true], [bu, bandU, true], [-bu, bandU, true]], true, mische(farbe, '#000000', dunkel ? 0 : 0.06), rand);
    aus.rumpf += linie([[-bu + 0.8, bandU + 1.1], [bu - 0.8, bandU + 1.1]], linieF, SW * 0.55, `stroke-dasharray="${r1(k * 0.7)} ${r1(k * 0.5)}" opacity=".6"`);
    if (f.band > 1.24)
      for (const s of [-1, 1])
        for (const t of [0.55, 0.78]) aus.rumpf += linie([[s * bo * t, bandO - 0.8], [s * bo * (t + 0.08), bandU + 1.6]], linieF, SW * 0.6, 'opacity=".45"');
    // Steppnaht auf den Trägern
    for (const s of [-1, 1]) {
      const x = s * (nwH + 0.9 + tr / 2);
      aus.rumpf += linie([[x, hps - 1.3], [x + s * 0.4, lerp(hps, m.achselH, 0.38)]], linieF, SW * 0.5, `stroke-dasharray="${r1(k * 0.6)} ${r1(k * 0.45)}" opacity=".5"`);
    }
    return aus;
  }

  function fellFlaeche([[x0, y0], [x1, y1]], farbe, kennung) {
    const id = `${kennung}-fell`;
    if (!defs.includes(`id="${id}"`))
      defs += `<pattern id="${id}" width="${r1(2.4 * k)}" height="${r1(2.1 * k)}" patternUnits="userSpaceOnUse"><circle cx="${r1(0.6 * k)}" cy="${r1(0.6 * k)}" r="${r1(0.55 * k)}" fill="${mische(farbe, '#ffffff', 0.35)}" opacity=".55"/><circle cx="${r1(1.8 * k)}" cy="${r1(1.6 * k)}" r="${r1(0.5 * k)}" fill="${mische(farbe, '#000000', 0.25)}" opacity=".35"/></pattern>`;
    const a = T([x0, y0]);
    const b = T([x1, y1]);
    return `<rect x="${r1(Math.min(a[0], b[0]))}" y="${r1(Math.min(a[1], b[1]))}" width="${r1(Math.abs(b[0] - a[0]))}" height="${r1(Math.abs(b[1] - a[1]))}" fill="url(#${id})"/>`;
  }

  const ebenen = [];
  if (teil && artVon(teil).ohneAermel)
    ebenen.push(kleidung({ art: 'longsleeve', brust: m.brU / 2 + 5, laenge: m.c7H + 1.8 - m.trochH + 4, schulter: m.akr + 2, aermel: m.armA + 2 }, '#f1f0ec', `${id}-u`));
  if (teil && istBH) ebenen.push(bhZeichnen(teil, farbe, id));
  else if (teil && !istHose) ebenen.push(kleidung(teil, farbe, id));
  if (istHose) {
    const shirt = hell(farbe) > 0.55 ? '#5d5b57' : '#f1f0ec';
    ebenen.push(kleidung({ art: 'shirt', brust: m.brU / 2 + 7, laenge: m.c7H + 1.8 - (hosenBund(m, artVon(teil)) + 0.6), schulter: m.akr + 4, aermel: 20 }, shirt, `${id}-t`));
  }
  const armOben = ebenen.length ? Math.min(...ebenen.map((e) => e.armOben)) : Infinity;

  // Arme (nur unterhalb des Ärmelendes sichtbar), Hände
  let arme = '';
  let haende = '';
  if (Number.isFinite(armOben)) defs += `<clipPath id="${id}-arm"><rect x="-500" y="${r1(T([0, armOben])[1])}" width="3000" height="3000"/></clipPath>`;
  for (const s of [-1, 1]) {
    const X = ([x, y, e]) => [s < 0 ? x : -x, y, e];
    arme += pfad(armPunkte.map(X), true, haut);
    haende += pfad(handPunkte().map(X), true, haut, `stroke="${hautSchatten}" stroke-width="${r1(SW * 0.6)}"`);
  }
  if (Number.isFinite(armOben)) arme = `<g clip-path="url(#${id}-arm)">${arme}</g>`;

  // Kopf, Hals, Ohren
  const kinn = S - hk;
  const hals = [[-nw * 0.42, kinn + 3], [nw * 0.42, kinn + 3], [nw / 2, m.c7H + 0.5], [-nw / 2, m.c7H + 0.5]];
  let kopf = pfad(hals, true, haut, '', 0.4);
  kopf += pfad([[-nw * 0.42, kinn + 3.5], [0, kinn + 1.4], [nw * 0.42, kinn + 3.5], [nw * 0.42, kinn + 6], [-nw * 0.42, kinn + 6]], true, hautSchatten, 'opacity=".55"', 0.6);
  for (const s of [-1, 1]) {
    const e = T([s * (kb / 2 - 0.2), S - hk * 0.5]);
    kopf += `<ellipse cx="${r1(e[0])}" cy="${r1(e[1])}" rx="${r1(1.4 * k)}" ry="${r1(2.9 * k)}" fill="${hautSchatten}"/>`;
  }
  const kp = [
    [0, S],
    [-(kb / 2) * 0.86, S - hk * 0.16],
    [-kb / 2, S - hk * 0.4],
    [-(kb / 2) * 0.9, S - hk * 0.66],
    [-(kb / 2) * 0.6, S - hk * 0.89],
    [-(kb / 2) * 0.22, S - hk * 0.995],
  ];
  kopf += pfad(kp.concat([[0, S - hk]], spiegel(kp).slice(0, -1)), true, haut);

  let mitte = arme + haende;
  if (ebenen.length) {
    mitte = ebenen.map((e) => e.hinten).join('') + ebenen[0].rumpf + arme + haende + ebenen[0].aermel;
    for (const e of ebenen.slice(1)) mitte += e.rumpf + e.aermel;
    mitte += ebenen.map((e) => e.kragenHinten).join('');
  }
  return `<g>${defs ? `<defs>${defs}</defs>` : ''}${svg}${mitte}${kopf}${ebenen.map((e) => e.vorn).join('')}</g>`;
}

// Sitz eines Teils an einem Körper (cm). luft = Umfang Teil − Brustumfang
function sitz(m, teil) {
  const A = artVon(teil);
  const schoppt = A.saum === 'rippe' && !(teil.bund >= teil.brust * 0.95);
  const stauchen = A.aermelEnde === 'rippe' || A.aermelEnde === 'gummi';
  const hps = m.c7H + 1.8;
  return {
    luft: teil.brust * 2 - m.brU,
    saum: hps - teil.laenge + (schoppt ? 3 : 0),
    drop: teil.schulter / 2 - m.akr / 2,
    // Rücken–Handgelenk bei hängendem Arm: halbe Schulterbreite + 2 cm Schulterschräge + Armaußennaht
    // (ANSUR misst „sleevelengthspinewrist“ mit angehobenem Arm, rund 9 cm länger)
    aermel: A.ohneAermel ? NaN : teil.schulter / 2 + teil.aermel - (m.akr / 2 + 2 + m.armA) - (stauchen ? 2 : 0),
  };
}


// Bund sitzt bei Sweatpants auf dem Beckenkamm, bei Leggings (Hochbund) knapp unter dem Nabel
function hosenBund(m, A) {
  return A.hochbund ? m.taH - 1 : m.beckenH + 1;
}

// Sitz einer Hose (cm): Dehnung des Gummibunds, Spielraum an Hüfte bzw. Oberschenkel, Saumhöhe über dem Boden
// (unter 0 = länger als das Bein, staucht sich über dem Schuh). Leggings dehnen sich auch in der Länge (+8 %).
function sitzHose(m, teil) {
  const A = artVon(teil);
  const anBund = A.hochbund ? m.taU : 0.6 * m.taU + 0.4 * m.hfU;
  const f = {};
  if (teil.hbund) f.dehnung = anBund / (2 * teil.hbund);
  if (teil.huefte) {
    f.luft = 2 * teil.huefte - m.hfU;
    f.weiteRel = f.luft / m.hfU;
    f.dehnungHuefte = m.hfU / (2 * teil.huefte);
  } else if (teil.oberschenkel) {
    f.luft = 2 * teil.oberschenkel - m.oschU;
    f.weiteRel = f.luft / m.oschU;
  }
  f.saum = teil.innenbein ? m.schrittH - A.drop - teil.innenbein : hosenBund(m, A) - teil.aussenbein * (A.eng ? 1.08 : 1);
  return f;
}

// Sitz eines Sport-BHs: Dehnung = Körperumfang / Umfang des Teils (halbe Weite × 2) – am Unterbrustband und an der Brust
function sitzBH(m, teil) {
  const f = {};
  if (teil.unterbrust) f.band = m.ubU / (2 * teil.unterbrust);
  if (teil.brust) f.brust = m.brU / (2 * teil.brust);
  return f;
}

// ---------- Maßtabelle (Theme-Einstellung „Foto-Fit: Maße“) ----------
const zahl = (s) => parseFloat(String(s).replace(',', '.'));
// Spaltennamen ohne Umlaute, Klammern und Leerzeichen („Brustweite (1/2)“ → brustweite)
const spalte = (s) => s.toLowerCase().replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss').replace(/\(.*?\)/g, '').replace(/[^a-z]/g, '');
const SPALTEN = {
  groesse: 'groessen', groessen: 'groessen',
  brust: 'brust', brustweite: 'brust',
  laenge: 'laenge', koerperlaenge: 'laenge',
  schulter: 'schulter', schulterbreite: 'schulter',
  aermel: 'aermel', aermellaenge: 'aermel',
  bund: 'bund', bundweite: 'bund',
  saum: 'saum', saumweite: 'saum',
  huefte: 'huefte', hueftweite: 'huefte',
  oberschenkel: 'oberschenkel', oberschenkelweite: 'oberschenkel',
  innenbein: 'innenbein', innenbeinlaenge: 'innenbein',
  beinlaenge: 'aussenbein', aussenbein: 'aussenbein', aussenbeinlaenge: 'aussenbein', gesamtlaenge: 'aussenbein',
  bundhoehe: 'bundhoehe',
  unterbrust: 'unterbrust', unterbrustweite: 'unterbrust',
};
const GROESSE = ['size', 'größe', 'groesse'];
const FARBE = ['color', 'colour', 'farbe'];
const GROESSEN_MUSTER = /^(xxs|xs|s|m|l|xl|xxl|xxxl|[2-6]xl)$/i;

function bezugLesen(text) {
  const s = String(text || '');
  const cm = s.match(/(\d{3})\s*cm/i);
  const meter = s.match(/(\d)[,.](\d{1,2})\s*m\b/i);
  const kg = s.match(/(\d{2,3})(?:[,.]\d)?\s*kg/i);
  const groesse = s.split(/[\s,;:·]+/).reverse().find((t) => GROESSEN_MUSTER.test(t));
  return {
    h: cm ? +cm[1] : meter ? Math.round(parseFloat(`${meter[1]}.${meter[2].padEnd(2, '0')}`) * 100) : null,
    w: kg ? +kg[1] : null,
    g: groesse ? groesse.toUpperCase() : null,
  };
}

// Model-Angabe je Farbe (Max 09.10.2026): „Black: 1,91 m, trägt XL; Off White: 1,83 m, trägt M“ – Teile mit Semikolon,
// vor dem Doppelpunkt eine oder mehrere Farben mit Komma (Teilwort reicht, z. B. „Bronze“). Ein Teil ohne erkannte
// Farben gilt für alle übrigen. Dieselben Regeln wie snippets/px-model-zeilen.liquid (Zeile unter der Größenwahl).
function modelTeil(text, farbe, alleFarben) {
  const norm = (s) => String(s || '').toLowerCase().replace(/\s+/g, ' ').trim();
  const jetzt = norm(farbe);
  const bekannt = alleFarben.map(norm).filter(Boolean);
  let standard = '';
  for (const roh of String(text || '').split(/[;\n]+/)) {
    const t = roh.trim();
    if (!t) continue;
    const i = t.indexOf(':');
    if (i > 0) {
      const items = t.slice(0, i).split(',').map(norm).filter(Boolean);
      const rest = t.slice(i + 1).trim();
      const farben = new Set();
      const allePassen =
        items.length > 0 &&
        items.every((x) => {
          const treffer = bekannt.filter((c) => c.includes(x) || x.includes(c));
          treffer.forEach((c) => farben.add(c));
          return treffer.length > 0;
        });
      if (allePassen && rest) {
        if (farben.has(jetzt)) return rest;
        continue;
      }
    }
    if (!standard) standard = t;
  }
  return standard;
}

// Größennamen angleichen: Model-Angaben schreiben mal „2XL“, die Tabellen „XXL“ (und umgekehrt, ebenso 3XL/XXXL)
const GROESSE_ALIAS = { '2XL': 'XXL', XXL: '2XL', '3XL': 'XXXL', XXXL: '3XL' };
function groesseImTab(tab, g) {
  if (!g) return null;
  if (tab.masse[g]) return g;
  return tab.masse[GROESSE_ALIAS[g]] ? GROESSE_ALIAS[g] : null;
}

function tabelleLesen(text) {
  const tab = { art: 'hoodie', masse: {}, roh: {}, groessen: [], status: '', bau: '', bezug: null, aermelAb: '' };
  const reihen = {};
  for (const roh of String(text || '').split(/\r?\n/)) {
    const z = roh.trim();
    if (!z || z.startsWith('#')) continue;
    const i = z.indexOf(':');
    if (i < 0) continue;
    const k = spalte(z.slice(0, i));
    const v = z.slice(i + 1).trim();
    if (k === 'art') tab.art = (ARTNAMEN.find(([muster]) => muster.test(v)) || [null, 'hoodie'])[1];
    else if (k === 'aermelab') tab.aermelAb = /hals|nacken|kragen/i.test(v) ? 'hals' : /mitte|rücken|ruecken/i.test(v) ? 'ruecken' : 'naht';
    else if (k === 'status') tab.status = v;
    else if (k === 'koerperbau' || k === 'figur') tab.bau = /dam|frau|weib/i.test(v) ? 'd' : 'h';
    else if (k === 'bezug' || k === 'model') tab.bezug = { ...bezugLesen(v), art: k };
    else if (SPALTEN[k]) reihen[SPALTEN[k]] = v.split(/[\s;|]+/).filter(Boolean);
  }
  const wert = (reihe, i) => {
    const w = reihen[reihe] ? zahl(reihen[reihe][i]) : NaN;
    return Number.isFinite(w) && w > 0 ? w : undefined;
  };
  const A = ARTEN[tab.art] || ARTEN.hoodie;
  tab.groessen = (reihen.groessen || []).map((g) => g.toUpperCase());
  let vorher = {};
  tab.groessen.forEach((g, i) => {
    // Sport-BH: halbe Brust- und Unterbrustweite (flach), keine Länge
    if (A.bh) {
      const m = { brust: wert('brust', i), unterbrust: wert('unterbrust', i) };
      for (const f of Object.keys(m)) if (m[f] === undefined) delete m[f];
      if (!m.unterbrust && !m.brust) return;
      tab.roh[g] = { ...m };
      tab.masse[g] = { art: tab.art, ...m };
      return;
    }
    if (A.hose) {
      const m = { hbund: wert('bund', i), huefte: wert('huefte', i), hsaum: wert('saum', i), innenbein: wert('innenbein', i), aussenbein: wert('aussenbein', i), oberschenkel: wert('oberschenkel', i), bundhoehe: wert('bundhoehe', i) };
      for (const f of Object.keys(m)) if (m[f] === undefined) delete m[f];
      if (!m.hbund && !m.huefte && !m.oberschenkel) return;
      tab.roh[g] = { ...m };
      // Fehlt die Länge einer Größe (z. B. 5XL), gilt die der Größe davor
      const laenge = { innenbein: m.innenbein ?? vorher.innenbein, aussenbein: m.aussenbein ?? vorher.aussenbein };
      if (!laenge.innenbein && !laenge.aussenbein) return;
      tab.masse[g] = { art: tab.art, ...m, ...laenge };
      vorher = tab.masse[g];
      return;
    }
    const m = { brust: wert('brust', i), laenge: wert('laenge', i), schulter: wert('schulter', i), aermel: wert('aermel', i), bund: wert('saum', i) ?? wert('bund', i) };
    for (const f of Object.keys(m)) if (m[f] === undefined) delete m[f];
    if (!m.brust || !m.laenge) return;
    tab.roh[g] = { ...m };
    tab.masse[g] = {
      art: tab.art,
      schulter: Math.round(m.brust * 0.84),
      aermel: A.ohneAermel ? 0 : tab.art === 'shirt' ? 23 : 58,
      ...m,
    };
  });
  return tab;
}

// Ärmellänge in „ab Schulternaht“ umrechnen. Hersteller messen unterschiedlich (Naht, Halsansatz, Rückenmitte); ohne
// Angabe „Ärmel ab:“ gilt der Ansatz, bei dem der Ärmel am Bezugskörper plausibel endet (rund 3 cm über das Handgelenk).
function aermelAngleichen(tab, bezug) {
  const t = tab.masse[bezug.g];
  const A = ARTEN[tab.art] || ARTEN.hoodie;
  if (!t || A.hose || A.ohneAermel || !tab.roh[bezug.g]?.aermel || t.aermel < 32) return;
  const hals = bezug.bau === 'd' ? 8 : 9;
  let ansatz = tab.aermelAb;
  if (!ansatz) {
    const mr = koerper({ bau: bezug.bau, h: bezug.h, w: bezug.w });
    const arm = mr.akr / 2 + 2 + mr.armA + (A.aermelEnde === 'rippe' || A.aermelEnde === 'gummi' ? 2 : 0);
    const abNaht = t.schulter / 2 + t.aermel - arm;
    const abHals = hals + t.aermel - arm;
    ansatz = Math.abs(abHals - 3) < Math.abs(abNaht - 3) ? 'hals' : 'naht';
  }
  tab.aermelAnsatz = ansatz;
  if (ansatz === 'naht') return;
  for (const g of Object.keys(tab.masse)) {
    const roh = tab.roh[g]?.aermel;
    if (!roh) continue;
    tab.masse[g].aermel = (ansatz === 'hals' ? hals + roh : roh) - tab.masse[g].schulter / 2;
  }
}

// ---------- Empfehlung ----------
const LOOK_WEITE = [-0.08, 0, 0.09];
const LOOK_SAUM = [0.12, 0, -0.15];

// Gesuchte Mehrweite in cm. Im Bezug besteht sie aus Grund-Spielraum, der mit dem Körper wächst (Shirts 10 %,
// Sweats 12 %, Jacken 16 % – die kommen über den Pulli), und Stil-Extra (dem „Oversized“-Anteil). Kräftigere Körper
// wählen weniger Stil-Extra: Es nimmt mit (Bezugsbrust / Brust)^k ab – bei Shirts und Sweats deutlich (k = 4,5), bei
// Jacken mäßig (k = 2). Geeicht an Max (08.10.2026): 181 cm, 120 kg trägt den Box Hoodie in XL; dieselbe prozentuale
// Mehrweite wie im Bezug ergab 4XL. Schlankere Körper als der Bezug behalten die prozentuale Mehrweite.
const WEITE_GRUND = { shirt: 0.1, longsleeve: 0.1, rollkragen: 0.1, hoodie: 0.12, zip: 0.12, sweater: 0.12 };
function luftZiel(m, mr, refLuft, art) {
  if (m.brU <= mr.brU) return (refLuft / mr.brU) * m.brU;
  const jacke = !(art in WEITE_GRUND);
  const grund = Math.min(refLuft, (jacke ? 0.16 : WEITE_GRUND[art]) * mr.brU);
  return (grund / mr.brU) * m.brU + (refLuft - grund) * (mr.brU / m.brU) ** (jacke ? 2 : 4.5);
}

function empfehlen(m, tab, bezug, look, groessen) {
  const mr = koerper({ bau: bezug.bau, h: bezug.h, w: bezug.w });
  if (ARTEN[tab.art]?.hose) return empfehlenHose(m, mr, tab, bezug, look, groessen);
  if (ARTEN[tab.art]?.bh) return empfehlenBH(m, mr, tab, bezug, look, groessen);
  const fr = sitz(mr, tab.masse[bezug.g]);
  const ziel = luftZiel(m, mr, fr.luft, tab.art) + LOOK_WEITE[look + 1] * m.brU;
  const saumZiel = (fr.saum - mr.schrittH) / (mr.beckenH - mr.schrittH) + LOOK_SAUM[look + 1];
  const spanne = m.beckenH - m.schrittH;
  const liste = groessen.map((g) => {
    const t = tab.masse[g];
    const f = sitz(m, t);
    let s = (Math.abs(f.luft - ziel) / m.brU) * 100 / 5 + (Math.abs((f.saum - m.schrittH) / spanne - saumZiel) * spanne) / 4;
    if (f.luft < 6) s += 20 + (6 - f.luft);
    return { g, f, s };
  });
  const sortiert = liste.slice().sort((a, b) => a.s - b.s);
  return { best: sortiert[0], zweit: sortiert[1], fr, mr };
}

// Hosen: Weite (cm) an Hüfte bzw. Oberschenkel wie gedacht, Gummibund weder rutschend noch spannend, Länge zweitrangig.
// Leggings: Dehnung an der Hüfte wie gedacht (Kompression), nicht über 1,45.
function empfehlenHose(m, mr, tab, bezug, look, groessen) {
  const A = ARTEN[tab.art];
  const fr = sitzHose(mr, tab.masse[bezug.g]);
  const liste = groessen.map((g) => {
    const f = sitzHose(m, tab.masse[g]);
    let s = 0;
    if (A.eng && f.dehnungHuefte) {
      s += Math.abs(f.dehnungHuefte - (fr.dehnungHuefte + [0.05, 0, -0.05][look + 1])) * 40;
      if (f.dehnungHuefte > 1.45) s += (f.dehnungHuefte - 1.45) * 80;
      if (f.dehnungHuefte < 1) s += (1 - f.dehnungHuefte) * 50;
    } else if (f.weiteRel !== undefined) {
      // Weite in Zentimetern: Bei Hosen bestimmt der absolute Stoffüberschuss die Optik
      s += Math.abs(f.luft - (fr.luft + [-6, 0, 7][look + 1])) / 4;
      if (f.luft < 4) s += 20 + (4 - f.luft);
    }
    // Gummibund: im bequemen Bereich (0,97–1,35) nur leicht gewichtet, darüber bzw. darunter deutlich
    if (f.dehnung && fr.dehnung) {
      s += Math.abs(f.dehnung - fr.dehnung) * 6;
      if (f.dehnung > 1.35) s += (f.dehnung - 1.35) * 30;
      if (f.dehnung > 1.5) s += (f.dehnung - 1.5) * 60;
      if (f.dehnung < 0.97) s += (0.97 - f.dehnung) * 25;
    }
    s += Math.abs(f.saum - fr.saum) / 8;
    return { g, f, s };
  });
  const sortiert = liste.slice().sort((a, b) => a.s - b.s);
  return { best: sortiert[0], zweit: sortiert[1], fr, mr };
}

// Sport-BH: Band und Brustteil so fest wie gedacht (Halt kommt vom Unterbrustband, deshalb zählt es doppelt). Band über
// 1,3 schnürt ein, unter 1,0 gibt es keinen Halt; das Brustteil darf etwas mehr dehnen (bis 1,42).
function empfehlenBH(m, mr, tab, bezug, look, groessen) {
  const fr = sitzBH(mr, tab.masse[bezug.g]);
  const ziel = [0.05, 0, -0.05][look + 1];
  const liste = groessen.map((g) => {
    const f = sitzBH(m, tab.masse[g]);
    let s = 0;
    if (f.band && fr.band) {
      s += Math.abs(f.band - (fr.band + ziel)) * 50;
      if (f.band > 1.3) s += (f.band - 1.3) * 90;
      if (f.band < 1) s += (1 - f.band) * 70;
    }
    if (f.brust && fr.brust) {
      s += Math.abs(f.brust - (fr.brust + ziel)) * 25;
      if (f.brust > 1.42) s += (f.brust - 1.42) * 60;
      if (f.brust < 1) s += (1 - f.brust) * 30;
    }
    return { g, f, s };
  });
  const sortiert = liste.slice().sort((a, b) => a.s - b.s);
  return { best: sortiert[0], zweit: sortiert[1], fr, mr };
}

// ---------- Worte für den Sitz ----------
const bandWort = (d, T) => (d < 1 ? T.band_locker : d < 1.08 ? T.band_leicht : d < 1.2 ? T.band_fest : d < 1.3 ? T.band_sehr : T.band_zu);
const komprWort = (d, T) => (d < 1 ? T.kompr_wenig : d < 1.1 ? T.kompr_leicht : d < 1.28 ? T.kompr_fest : d < 1.42 ? T.kompr_sehr : T.kompr_zu);
const bundWort = (d, T) => (d < 0.97 ? T.b_locker : d < 1.35 ? T.b_bequem : d < 1.5 ? T.b_fest : T.b_eng);
const leggingsWort = (d, T) => (d < 1 ? T.lg_locker : d < 1.12 ? T.lg_leicht : d < 1.3 ? T.lg_eng : d < 1.45 ? T.lg_sehr : T.lg_zu);
const hosenLaengeWort = (s, m, T) => (s < -4 ? T.hl_stapel_stark : s < 2 ? T.hl_stapel : s < m.knoechelH - 1 ? T.hl_schuh : s < m.knoechelH + 4 ? T.hl_knoechel : s < m.knoechelH + 14 ? T.hl_78 : T.hl_kurz);
function weiteWort(luft, T) {
  return luft < 4 ? T.w_spannt : luft < 12 ? T.w_koerpernah : luft < 22 ? T.w_bequem : luft < 34 ? T.w_locker : luft < 50 ? T.w_oversized : T.w_extrem;
}
function laengeWort(f, m, T) {
  const s = f.saum;
  if (s >= m.beckenH) return T.l_kurz;
  if (s >= m.trochH) return T.l_huefte;
  if (s >= m.schrittH + 2) return T.l_po_halb;
  if (s >= m.schrittH - (m.schrittH - m.knieH) * 0.3) return T.l_po;
  if (s >= (m.schrittH + m.knieH) / 2) return T.l_schenkel;
  return T.l_knie;
}
// Ärmel relativ zum Bezug (Model bzw. so gedacht): Die Messweise der Hersteller (ab Naht, Hals, Rücken) kürzt sich heraus
function aermelWort(f, fr, mitFoto, T) {
  const d = Math.round(f.aermel - fr.aermel);
  if (Math.abs(d) < 2) return mitFoto ? T.a_gleich_foto : T.a_gleich;
  return ersetze(d > 0 ? (mitFoto ? T.a_laenger_foto : T.a_laenger) : mitFoto ? T.a_kuerzer_foto : T.a_kuerzer, { wert: Math.abs(d) });
}
const schulterWort = (drop, T) => (drop < 1.5 ? T.s_auf : T.s_tiefer.replace('{wert}', Math.round(drop)));
const meter = (h) => `${(h / 100).toFixed(2).replace('.', ',')} m`;
const ersetze = (s, werte) => Object.entries(werte).reduce((a, [k, v]) => a.split(`{${k}}`).join(v), String(s));

// ---------- Profil (nur auf Wunsch, nur auf diesem Gerät) ----------
const SPEICHER = 'px-fotofit';
function profilLesen() {
  try {
    const p = JSON.parse(localStorage.getItem(SPEICHER) || 'null');
    return p && p.h && p.w ? p : null;
  } catch {
    return null;
  }
}
function profilSchreiben(st) {
  try {
    if (st.merken) localStorage.setItem(SPEICHER, JSON.stringify({ bau: st.bau, h: st.h, w: st.w, schulter: st.schulter, bauch: st.bauch, huefte: st.huefte, oberweite: st.oberweite, look: st.look }));
    else localStorage.removeItem(SPEICHER);
  } catch {
    // Speicher gesperrt (privates Fenster) – Foto-Fit funktioniert trotzdem
  }
}

// ---------- Symbole für die Figur-Auswahl ----------
// Schultern frontal, Bauch im Profil – so erkennt man den Unterschied auf den ersten Blick
function symbolSchulter(bau, wert) {
  const d = bau === 'd';
  const s = (d ? 9.4 : 10.6) + wert * 2.4;
  const w = d ? 7 : 7.6;
  const h = d ? 8.8 : 8;
  const links = [
    [21.6, 15.6],
    [24 - s * 0.55, 17.6],
    [24 - s, 19.8],
    [24 - s - 1.3, 22.6],
    [24 - s - 1.6, 30],
    [24 - s - 1.1, 37.6, true],
    [24 - s + 1.6, 37.6, true],
    [24 - s + 1.4, 26.5],
    [24 - w - 0.6, 26],
    [24 - w, 33.5],
    [24 - h, 41],
    [24 - h + 0.3, 47, true],
  ];
  const rechts = links.slice().reverse().map(([x, y, e]) => [48 - x, y, e]);
  return `<svg viewBox="0 0 48 52" width="40" height="44" aria-hidden="true" focusable="false"><circle cx="24" cy="9.6" r="5.2" fill="currentColor"/><path d="${kurve(links.concat(rechts), true)}" fill="currentColor"/></svg>`;
}
function symbolHuefte(bau, wert) {
  const d = bau === 'd';
  const t = d ? 7.2 : 8;
  const hh = (d ? 10.6 : 9.6) + wert * 2.3;
  const links = [
    [24 - t, 8, true],
    [24 - t - 0.4, 12],
    [24 - hh, 19],
    [24 - hh + 0.8, 26],
    [24 - (hh * 0.62 + 1.4), 36],
    [24 - 5.4, 46],
    [24 - 4.6, 50, true],
    [24 - 1.4, 50, true],
    [24 - 1.6, 40],
    [24 - 0.6, 28, true],
  ];
  const rechts = links.slice().reverse().map(([x, y, e]) => [48 - x, y, e]);
  return `<svg viewBox="0 0 48 52" width="40" height="44" aria-hidden="true" focusable="false"><path d="${kurve(links.concat(rechts), true)}" fill="currentColor"/></svg>`;
}
function symbolBauch(bau, wert) {
  const b = [0, 2.8, 6.4][wert + 1];
  const c = bau === 'd' ? 3 : 1.2;
  const profil = [
    [21.4, 15.8],
    [19.8, 19.5],
    [19.3, 28],
    [19.9, 35.5],
    [18.5, 41.5],
    [19.4, 48.5, true],
    [27.2, 48.5, true],
    [27.4 + b * 0.15, 44.5],
    [27.8 + b * 0.6, 40],
    [28.2 + b, 34.6],
    [27.6 + b * 0.55, 29.2],
    [27.6 + c, 24],
    [26.4, 19.6],
    [25, 16.4],
  ];
  return `<svg viewBox="0 0 48 52" width="40" height="44" aria-hidden="true" focusable="false"><circle cx="23.4" cy="9.6" r="5.2" fill="currentColor"/><path d="${kurve(profil, true)}" fill="currentColor"/></svg>`;
}

// Oberweite im Profil (nur beim Sport-BH): Wölbung der Brust, Bauch flach
function symbolOberweite(bau, wert) {
  const c = (bau === 'd' ? [0.6, 3.4, 6.8] : [0.3, 1.3, 2.6])[wert + 1];
  const profil = [
    [21.4, 15.8],
    [19.8, 19.5],
    [19.3, 28],
    [19.9, 35.5],
    [18.5, 41.5],
    [19.4, 48.5, true],
    [27.2, 48.5, true],
    [27.4, 44.5],
    [27.6, 40],
    [27.9, 34.6],
    [27.2 + c * 0.35, 29.4],
    [27.4 + c, 24.6],
    [26.6 + c * 0.25, 20],
    [25, 16.4],
  ];
  return `<svg viewBox="0 0 48 52" width="40" height="44" aria-hidden="true" focusable="false"><circle cx="23.4" cy="9.6" r="5.2" fill="currentColor"/><path d="${kurve(profil, true)}" fill="currentColor"/></svg>`;
}

// ---------- Baustein ----------
function einrichten(wurzel) {
  const lies = (sel) => {
    try {
      return JSON.parse(wurzel.querySelector(sel)?.textContent || 'null');
    } catch {
      return null;
    }
  };
  const daten = lies('[data-px-ff-daten]');
  const T = lies('[data-px-ff-texte]') || {};
  const fenster = document.getElementById(wurzel.dataset.pxFf);
  if (!daten || !fenster) return;
  const tab = tabelleLesen(daten.tabelle);
  const optionen = (daten.optionen || []).map((o) => String(o).toLowerCase().trim());
  const gi = optionen.findIndex((o) => GROESSE.includes(o));
  const fi = optionen.findIndex((o) => FARBE.includes(o));
  const varianten = daten.varianten || [];
  const groessen = [...new Set(varianten.map((v) => String(v.o[gi]).toUpperCase()))].filter((g) => tab.masse[g]);
  if (gi < 0 || groessen.length < 2) {
    wurzel.hidden = true;
    return;
  }
  const echteGroesse = (g) => varianten.map((v) => v.o[gi]).find((w) => String(w).toUpperCase() === g) || g;

  const bereich = wurzel.closest('.product-details, product-info, [data-product-id], section') || document;
  const farbName = () => {
    const ein = [...bereich.querySelectorAll('variant-picker input[type="radio"]:checked')].find((i) => FARBE.includes((i.dataset.optionName || '').toLowerCase().trim()));
    return ein?.value || (fi >= 0 ? varianten[0]?.o[fi] : '') || '';
  };

  // Bezug: Model-Angabe am Produkt – je Farbe möglich (modelTeil) –, sonst die Bezugszeile der Tabelle
  const alleFarben = fi >= 0 ? [...new Set(varianten.map((v) => String(v.o[fi])))] : [];
  const bezugFuer = (farbe) => {
    const model = bezugLesen(modelTeil(daten.model, farbe, alleFarben));
    model.g = groesseImTab(tab, model.g);
    let b;
    if (model.h && model.g) b = { art: 'model', ...model };
    else if (tab.bezug?.h && tab.bezug?.g && tab.masse[tab.bezug.g]) b = { ...tab.bezug };
    else b = { art: 'bezug', h: 178, w: 76, g: groessen[Math.min(1, groessen.length - 1)] };
    b.w = b.w || Math.round(22.5 * (b.h / 100) ** 2);
    b.bau = tab.bau || (daten.damen ? 'd' : 'h');
    return b;
  };
  let bezug = bezugFuer(farbName());
  aermelAngleichen(tab, bezug);
  const istHose = !!ARTEN[tab.art]?.hose;
  const istBH = !!ARTEN[tab.art]?.bh;
  let mitFoto = bezug.art === 'model';
  // Hosen: Hüfte statt Schultern; Sport-BH: Oberweite statt Schultern
  const feldSchulter = fenster.querySelector('[data-px-ff-feld-schulter]');
  const feldHuefte = fenster.querySelector('[data-px-ff-feld-huefte]');
  const feldOberweite = fenster.querySelector('[data-px-ff-feld-oberweite]');
  if (feldSchulter) feldSchulter.hidden = istHose || istBH;
  if (feldHuefte) feldHuefte.hidden = !istHose;
  if (feldOberweite) feldOberweite.hidden = !istBH;
  // Die Oberweite zählt nur beim Sport-BH (sonst wirkte sie unsichtbar auf Oberteile)
  const koerperVon = (s) => koerper({ ...s, oberweite: istBH ? s.oberweite : 0 });
  const unter = fenster.querySelector('[data-px-ff-unter]');
  if (unter) unter.textContent = mitFoto ? T.titel_model : T.titel_bezug;

  const gespeichert = profilLesen();
  const st = {
    bau: bezug.bau,
    h: bezug.bau === 'd' ? 166 : 178,
    w: bezug.bau === 'd' ? 62 : 78,
    schulter: 0,
    bauch: 0,
    huefte: 0,
    oberweite: 0,
    look: 0,
    gr: null,
    fertig: false,
    merken: false,
    ...(gespeichert ? { ...gespeichert, fertig: true, merken: true } : {}),
  };
  const beruehrt = { h: !!gespeichert, w: !!gespeichert };

  const teil = (name) => fenster.querySelector(`[data-px-ff-${name}]`);

  const farbHex = (name) => {
    const tabelle = document.getElementById('PxSchnellkauf')?.dataset.farben || '';
    const key = `|${String(name).toLowerCase().trim()}=`;
    const i = tabelle.indexOf(key);
    if (i < 0) return null;
    const wert = tabelle.slice(i + key.length).split('|')[0].trim().split(/\s+/)[0];
    return /^#[0-9a-f]{3,6}$/i.test(wert) ? wert : null;
  };
  const lieferbar = (g) => {
    const farbe = farbName();
    return varianten.some((v) => String(v.o[gi]).toUpperCase() === g && v.a && (fi < 0 || !farbe || v.o[fi] === farbe));
  };

  // Startzeile auf der Produktseite
  const startTitel = wurzel.querySelector('[data-px-ff-start-titel]');
  const startUnter = wurzel.querySelector('[data-px-ff-start-unter]');
  startTitel.dataset.leer = startTitel.textContent;
  startUnter.dataset.leer = startUnter.textContent;
  const startZeigen = () => {
    if (!st.fertig || !st.merken) return;
    const e = empfehlen(koerperVon(st), tab, bezug, st.look, groessen);
    startTitel.textContent = ersetze(T.start_profil, { groesse: echteGroesse(e.best.g) });
    startUnter.textContent = T.start_profil_unter;
  };
  startZeigen();

  // Auswahlknöpfe
  const knopfgruppe = (name, werte, beschriften) => {
    const gruppe = teil(name);
    gruppe.replaceChildren();
    werte.forEach((wert) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'px-ff-wahl';
      b.dataset.wert = wert;
      b.innerHTML = beschriften(wert);
      gruppe.append(b);
    });
  };
  const symboleZeichnen = () => {
    knopfgruppe('schulter', [-1, 0, 1], (w) => `${symbolSchulter(st.bau, w)}<span>${[T.schmal, T.normal, T.breit][w + 1]}</span>`);
    knopfgruppe('bauch', [-1, 0, 1], (w) => `${symbolBauch(st.bau, w)}<span>${[T.flach, T.normal, T.kraeftig][w + 1]}</span>`);
    if (feldHuefte) knopfgruppe('huefte', [-1, 0, 1], (w) => `${symbolHuefte(st.bau, w)}<span>${[T.schmal, T.normal, T.breit][w + 1]}</span>`);
    if (feldOberweite) knopfgruppe('oberweite', [-1, 0, 1], (w) => `${symbolOberweite(st.bau, w)}<span>${[T.ow_klein, T.ow_mittel, T.ow_gross][w + 1]}</span>`);
  };
  knopfgruppe('bau', ['h', 'd'], (w) => `<span>${w === 'd' ? T.damen : T.herren}</span>`);
  // Sport-BH: „fester/lockerer“ statt „schmaler/weiter“
  const lookEnden = istBH ? [T.look_fester, T.look_lockerer] : [T.look_schmaler, T.look_weiter];
  knopfgruppe('look', [-1, 0, 1], (w) => `<span>${[lookEnden[0], mitFoto ? T.look_foto : T.look_gedacht, lookEnden[1]][w + 1]}</span>`);
  symboleZeichnen();

  const hoehe = teil('h');
  const gewicht = teil('w');
  const merken = teil('merken');

  // Neu zeichnen im nächsten Bild – mit Rückfall per Timer, falls der Browser Bilder aussetzt (Tab im Hintergrund)
  let geplant = 0;
  let notfall = 0;
  const los = () => {
    cancelAnimationFrame(geplant);
    clearTimeout(notfall);
    zeichnen();
  };
  const neuZeichnen = () => {
    cancelAnimationFrame(geplant);
    clearTimeout(notfall);
    geplant = requestAnimationFrame(los);
    notfall = setTimeout(los, 120);
  };

  function zeichnen() {
    st.fertig = beruehrt.h && beruehrt.w;
    const m = koerperVon(st);
    const e = empfehlen(m, tab, bezug, st.look, groessen);
    const g = st.gr && tab.masse[st.gr] ? st.gr : e.best.g;
    const f = istHose ? sitzHose(m, tab.masse[g]) : istBH ? sitzBH(m, tab.masse[g]) : sitz(m, tab.masse[g]);
    const farbe = farbHex(farbName()) || '#cdc6b8';
    const k = 1.8;
    const boden = 392;
    const oben = Math.round(boden - Math.max(e.mr.h, m.h, 182) * k - 12);
    teil('svg').setAttribute('viewBox', `0 ${oben} 380 ${boden + 8 - oben}`);
    teil('svg').innerHTML =
      `<line x1="8" x2="372" y1="${boden + 1}" y2="${boden + 1}" stroke="currentColor" stroke-opacity=".14"/>` +
      figur(e.mr, tab.masse[bezug.g], { cx: 98, boden, k, farbe, id: `${fenster.id}-r` }) +
      `<g${st.fertig ? '' : ' opacity=".28"'}>${figur(m, tab.masse[g], { cx: 280, boden, k, farbe, id: `${fenster.id}-d` })}</g>`;
    teil('name-ref').innerHTML = `<strong>${mitFoto ? T.ref_model : T.ref_bezug}</strong> ${meter(bezug.h)} · ${mitFoto ? `${T.traegt} ` : ''}${echteGroesse(bezug.g)}`;
    teil('name-du').innerHTML = `<strong>${T.du}</strong> ${meter(st.h)} · ${st.w} kg · ${echteGroesse(g)}`;

    const empf = teil('empf');
    const alt = teil('alt');
    if (!st.fertig) {
      empf.textContent = T.eingeben;
      alt.textContent = '';
    } else {
      const satz = istBH
        ? [T.empf_fester, mitFoto ? T.empf_foto : T.empf_gedacht, T.empf_lockerer][st.look + 1]
        : [T.empf_schmaler, mitFoto ? T.empf_foto : T.empf_gedacht, T.empf_weiter][st.look + 1];
      empf.innerHTML = ersetze(satz, { groesse: `<strong>${echteGroesse(e.best.g)}</strong>` });
      const bf = e.best.f;
      const eng = ARTEN[tab.art]?.eng;
      const zuEng = istBH ? bf.band > 1.3 || bf.brust > 1.42 : istHose ? (eng ? bf.dehnungHuefte > 1.45 : bf.luft < 4 || bf.dehnung > 1.5) : bf.luft < 4;
      const kaumWeit = istBH ? false : istHose ? !eng && bf.luft < 10 : bf.luft < 12;
      if (zuEng) alt.textContent = ersetze(T.zu_eng, { groesse: echteGroesse(groessen[groessen.length - 1]) });
      else if (kaumWeit) alt.textContent = T.kaum_weit;
      else if (istBH && bf.band < 1) alt.textContent = T.bh_locker;
      else if (istBH && e.zweit)
        alt.textContent = ersetze(T.zweite_bh, { groesse: echteGroesse(e.zweit.g), sitz: (e.zweit.f.band ?? 0) > (bf.band ?? 0) ? T.fester : T.lockerer });
      else if (e.zweit)
        alt.textContent = ersetze(T.zweite, {
          groesse: echteGroesse(e.zweit.g),
          weite: e.zweit.f.luft > e.best.f.luft ? T.weiter : T.schmaler,
          laenge: e.zweit.f.saum < e.best.f.saum ? T.laenger : T.kuerzer,
        });
    }

    // Größenknöpfe
    const reihe = teil('groessen');
    if (reihe.childElementCount !== groessen.length) {
      reihe.replaceChildren(
        ...groessen.map((gr) => {
          const b = document.createElement('button');
          b.type = 'button';
          b.className = 'px-ff-gr';
          b.dataset.groesse = gr;
          b.textContent = echteGroesse(gr);
          return b;
        })
      );
    }
    for (const b of reihe.children) {
      b.setAttribute('aria-pressed', String(b.dataset.groesse === g));
      b.classList.toggle('ist-empfohlen', st.fertig && b.dataset.groesse === e.best.g);
      b.classList.toggle('ist-aus', !lieferbar(b.dataset.groesse));
    }

    // Sitz in Worten
    const vergleich = mitFoto ? T.vergleich_foto : T.vergleich_gedacht;
    const plusCm = (v) => `${v >= 0 ? '+' : '−'}${Math.abs(Math.round(v))} cm`;
    const teilG = tab.masse[g];
    const zeilen = istBH ? [
      f.band && [T.r_unterbrust, bandWort(f.band, T), e.fr.band && bandWort(e.fr.band, T)],
      f.brust && [T.r_brust, komprWort(f.brust, T), e.fr.brust && komprWort(e.fr.brust, T)],
    ].filter(Boolean) : istHose ? [
      f.dehnung && e.fr.dehnung && [T.r_bund, bundWort(f.dehnung, T), bundWort(e.fr.dehnung, T)],
      ARTEN[tab.art].eng
        ? f.dehnungHuefte && [T.r_huefte, leggingsWort(f.dehnungHuefte, T), leggingsWort(e.fr.dehnungHuefte, T)]
        : f.luft !== undefined && [teilG.huefte ? T.r_huefte : T.r_oberschenkel, `${weiteWort(f.luft, T)} · ${T.umfang} ${plusCm(f.luft)}`, `${weiteWort(e.fr.luft, T)} · ${plusCm(e.fr.luft)}`],
      [T.laenge, hosenLaengeWort(f.saum, m, T), hosenLaengeWort(e.fr.saum, e.mr, T)],
    ].filter(Boolean) : [
      [T.weite, `${weiteWort(f.luft, T)} · ${T.umfang} ${plusCm(f.luft)}`, `${weiteWort(e.fr.luft, T)} · ${plusCm(e.fr.luft)}`],
      [T.laenge, laengeWort(f, m, T), laengeWort(e.fr, e.mr, T)],
      // Ärmel und Schulternaht nur, wenn der Hersteller sie misst (sonst wären es Schätzungen)
      tab.roh[g]?.aermel && tab.roh[bezug.g]?.aermel && [T.aermel, aermelWort(f, e.fr, mitFoto, T)],
      tab.roh[g]?.schulter && tab.roh[bezug.g]?.schulter && [T.schulter, schulterWort(f.drop, T), schulterWort(e.fr.drop, T)],
    ].filter(Boolean);
    teil('werte').innerHTML = zeilen
      .map(([a, b, c]) => `<div><dt>${a}</dt><dd>${b}${c ? `<span>${vergleich}: ${c}</span>` : ''}</dd></div>`)
      .join('');

    // Knopf
    const waehlen = teil('waehlen');
    waehlen.textContent = ersetze(T.waehlen, { groesse: echteGroesse(g) });
    waehlen.dataset.groesse = g;
    waehlen.disabled = !st.fertig && !st.gr;
    teil('aus').textContent = lieferbar(g) ? '' : ersetze(T.ausverkauft, { groesse: echteGroesse(g) });

    // Auswahl-Zustände
    const druck = (name, aktiv) => {
      for (const b of teil(name).children) b.setAttribute('aria-pressed', String(aktiv(b.dataset.wert)));
    };
    druck('bau', (w) => w === st.bau);
    druck('schulter', (w) => +w === st.schulter);
    druck('bauch', (w) => +w === st.bauch);
    if (feldHuefte) druck('huefte', (w) => +w === st.huefte);
    if (feldOberweite) druck('oberweite', (w) => +w === st.oberweite);
    druck('look', (w) => +w === st.look);
    hoehe.value = st.h;
    gewicht.value = st.w;
    teil('h-wert').textContent = `${st.h} cm`;
    teil('w-wert').textContent = `${st.w} kg`;
    merken.checked = st.merken;
    profilSchreiben(st);
    startZeigen();
  }

  // Maßtabelle im Fenster
  const masse = teil('masstabelle');
  if (masse) {
    const felder = (istBH ? ['brust', 'unterbrust'] : istHose ? ['hbund', 'huefte', 'oberschenkel', 'hsaum', 'innenbein', 'aussenbein'] : ['brust', 'laenge', 'schulter', 'aermel', 'bund']).filter((f) => groessen.some((g) => tab.roh[g]?.[f]));
    masse.innerHTML =
      `<thead><tr><th scope="col">${T.groesse}</th>${felder.map((f) => `<th scope="col">${T[`m_${f}`]}</th>`).join('')}</tr></thead><tbody>` +
      groessen.map((g) => `<tr><th scope="row">${echteGroesse(g)}</th>${felder.map((f) => `<td>${tab.roh[g]?.[f] ? String(tab.roh[g][f]).replace('.', ',') : '–'}</td>`).join('')}</tr>`).join('') +
      '</tbody>';
    teil('vorlaeufig').hidden = !/vorläufig|vorlaeufig|geschätzt/i.test(tab.status);
  }

  // Bedienung
  fenster.addEventListener('click', (event) => {
    const ziel = event.target instanceof Element ? event.target : null;
    if (!ziel) return;
    if (ziel === fenster || ziel.closest('[data-px-ff-zu]')) {
      fenster.close();
      return;
    }
    const wahl = ziel.closest('.px-ff-wahl');
    if (wahl) {
      const gruppe = wahl.parentElement.dataset;
      if ('pxFfBau' in gruppe) {
        if (st.bau !== wahl.dataset.wert) {
          st.bau = wahl.dataset.wert;
          symboleZeichnen();
        }
      } else if ('pxFfSchulter' in gruppe) st.schulter = +wahl.dataset.wert;
      else if ('pxFfHuefte' in gruppe) st.huefte = +wahl.dataset.wert;
      else if ('pxFfOberweite' in gruppe) st.oberweite = +wahl.dataset.wert;
      else if ('pxFfBauch' in gruppe) st.bauch = +wahl.dataset.wert;
      else if ('pxFfLook' in gruppe) st.look = +wahl.dataset.wert;
      st.gr = null;
      neuZeichnen();
      return;
    }
    const gr = ziel.closest('.px-ff-gr');
    if (gr) {
      st.gr = gr.dataset.groesse;
      neuZeichnen();
      return;
    }
    const waehlen = ziel.closest('[data-px-ff-waehlen]');
    if (waehlen && waehlen.dataset.groesse) {
      groesseWaehlen(echteGroesse(waehlen.dataset.groesse));
      fenster.close();
    }
  });
  hoehe.addEventListener('input', () => {
    st.h = +hoehe.value;
    beruehrt.h = true;
    st.gr = null;
    neuZeichnen();
  });
  gewicht.addEventListener('input', () => {
    st.w = +gewicht.value;
    beruehrt.w = true;
    st.gr = null;
    neuZeichnen();
  });
  merken.addEventListener('change', () => {
    st.merken = merken.checked;
    profilSchreiben(st);
    if (!st.merken) {
      startTitel.textContent = startTitel.dataset.leer;
      startUnter.textContent = startUnter.dataset.leer;
    }
    startZeigen();
  });
  fenster.addEventListener('close', startZeigen);

  function groesseWaehlen(wert) {
    const passt = (el) => GROESSE.includes((el.dataset.optionName || el.name || '').toLowerCase().replace(/^options\[|\]$/g, '').trim());
    const knopf = [...bereich.querySelectorAll('variant-picker input[type="radio"]')].find((i) => passt(i) && i.value === wert);
    if (knopf) {
      if (!knopf.checked) knopf.click();
      return;
    }
    const auswahl = [...bereich.querySelectorAll('variant-picker select')].find(passt);
    const option = auswahl && [...auswahl.options].find((o) => o.value === wert || o.textContent.trim() === wert);
    if (option) {
      auswahl.value = option.value;
      auswahl.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  // Andere Farbe, anderes Model: Bezug neu bestimmen (Model-Angabe je Farbe), Beschriftungen nachziehen
  const bezugAktualisieren = () => {
    const neu = bezugFuer(farbName());
    if (neu.art === bezug.art && neu.h === bezug.h && neu.w === bezug.w && neu.g === bezug.g) return false;
    bezug = neu;
    mitFoto = bezug.art === 'model';
    if (unter) unter.textContent = mitFoto ? T.titel_model : T.titel_bezug;
    const mitte = teil('look')?.querySelector('[data-wert="0"] span');
    if (mitte) mitte.textContent = mitFoto ? T.look_foto : T.look_gedacht;
    return true;
  };
  bereich.addEventListener('change', (event) => {
    if (!(event.target instanceof Element) || !event.target.closest('variant-picker')) return;
    setTimeout(() => {
      if (bezugAktualisieren()) startZeigen();
    }, 0);
  });

  wurzel.querySelector('[data-px-ff-oeffnen]')?.addEventListener('click', () => {
    bezugAktualisieren();
    zeichnen();
    fenster.showModal();
    (st.fertig ? teil('waehlen') : hoehe).focus({ preventScroll: true });
  });

  // Nach unten ziehen schließt (am Griff oder Kopf)
  let start = null;
  const blatt = fenster.querySelector('[data-px-ff-blatt]');
  const griff = fenster.querySelector('[data-px-ff-griff]');
  griff?.addEventListener('touchstart', (e) => (start = e.touches[0].clientY), { passive: true });
  griff?.addEventListener('touchmove', (e) => {
    if (start === null) return;
    const weg = Math.max(0, e.touches[0].clientY - start);
    blatt.style.transform = weg ? `translateY(${weg}px)` : '';
  }, { passive: true });
  griff?.addEventListener('touchend', (e) => {
    if (start === null) return;
    const weg = (e.changedTouches[0]?.clientY ?? start) - start;
    blatt.style.transform = '';
    start = null;
    if (weg > 90) fenster.close();
  });
}

for (const wurzel of document.querySelectorAll('[data-px-ff]')) einrichten(wurzel);
